export default [
  {
    countryNameEn: 'Andorra',
    countryNameLocal: 'Andorra',
    countryCode: 'AD',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ca',
    officialLanguageNameEn: 'Catalan, Valencian',
    officialLanguageNameLocal: 'Català, Valencià',
    countryCallingCode: '376',
    region: 'Europe',
    flag: '🇦🇩',
    countryCodeAlpha3: 'AND',
    center: [42.5, 1.6],
  },
  {
    countryNameEn: 'Afghanistan',
    countryNameLocal: 'د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان',
    countryCode: 'AF',
    currencyCode: 'AFN',
    currencyNameEn: 'Afghan afghani',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fa',
    officialLanguageNameEn: 'Persian',
    officialLanguageNameLocal: 'فارسی',
    countryCallingCode: '93',
    region: 'Asia & Pacific',
    flag: '🇦🇫',
    countryCodeAlpha3: 'AFG',
    center: [33, 65],
  },
  {
    countryNameEn: 'Antigua and Barbuda',
    countryNameLocal: 'Antigua and Barbuda',
    countryCode: 'AG',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1268',
    region: 'South/Latin America',
    flag: '🇦🇬',
    countryCodeAlpha3: 'ATG',
    center: [17.05, -61.8],
  },
  {
    countryNameEn: 'Anguilla',
    countryNameLocal: 'Anguilla',
    countryCode: 'AI',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1264',
    region: 'South/Latin America',
    flag: '🇦🇮',
    countryCodeAlpha3: 'AIA',
    center: [18.25, -63.1667],
  },
  {
    countryNameEn: 'Albania',
    countryNameLocal: 'Shqipëria',
    countryCode: 'AL',
    currencyCode: 'ALL',
    currencyNameEn: 'Albanian lek',
    tinType: 'NIPT',
    tinName: 'Numri i Identifikimit për Personin e Tatueshëm',
    officialLanguageCode: 'sq',
    officialLanguageNameEn: 'Albanian',
    officialLanguageNameLocal: 'Shqip',
    countryCallingCode: '355',
    region: 'Europe',
    flag: '🇦🇱',
    countryCodeAlpha3: 'ALB',
    center: [41, 20],
  },
  {
    countryNameEn: 'Armenia',
    countryNameLocal: 'Հայաստան',
    countryCode: 'AM',
    currencyCode: 'AMD',
    currencyNameEn: 'Armenian dram',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'hy',
    officialLanguageNameEn: 'Armenian',
    officialLanguageNameLocal: 'Հայերեն',
    countryCallingCode: '374',
    region: 'Europe',
    flag: '🇦🇲',
    countryCodeAlpha3: 'ARM',
    center: [40, 45],
  },
  {
    countryNameEn: 'Angola',
    countryNameLocal: 'Angola',
    countryCode: 'AO',
    currencyCode: 'AOA',
    currencyNameEn: 'Angolan kwanza',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '244',
    region: 'Africa',
    flag: '🇦🇴',
    countryCodeAlpha3: 'AGO',
    center: [-12.5, 18.5],
  },
  {
    countryNameEn: 'Antarctica',
    countryNameLocal: 'Antarctica, Antártico, Antarctique, Антарктике',
    countryCode: 'AQ',
    currencyCode: 'AAD',
    currencyNameEn: 'Antarctic Dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '',
    region: 'Asia & Pacific',
    flag: '🇦🇶',
    countryCodeAlpha3: 'ATA',
    center: [-90, 0],
  },
  {
    countryNameEn: 'Argentina',
    countryNameLocal: 'Argentina',
    countryCode: 'AR',
    currencyCode: 'ARS',
    currencyNameEn: 'Argentine peso',
    tinType: 'CUIT',
    tinName: 'Código Único de Identificación Tributaria',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '54',
    region: 'South/Latin America',
    flag: '🇦🇷',
    countryCodeAlpha3: 'ARG',
    center: [-34, -64],
  },
  {
    countryNameEn: 'American Samoa',
    countryNameLocal: 'American Samoa',
    countryCode: 'AS',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1684',
    region: 'Asia & Pacific',
    flag: '🇦🇸',
    countryCodeAlpha3: 'ASM',
    center: [-14.3333, -170],
  },
  {
    countryNameEn: 'Austria',
    countryNameLocal: 'Österreich',
    countryCode: 'AT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'UID',
    tinName: 'Umsatzsteuer-Identifikationsnummer',
    officialLanguageCode: 'de',
    officialLanguageNameEn: 'German',
    officialLanguageNameLocal: 'Deutsch',
    countryCallingCode: '43',
    region: 'Europe',
    flag: '🇦🇹',
    countryCodeAlpha3: 'AUT',
    center: [47.3333, 13.3333],
  },
  {
    countryNameEn: 'Australia',
    countryNameLocal: 'Australia',
    countryCode: 'AU',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: 'ABN',
    tinName: 'Australian Business Number',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '61',
    region: 'Asia & Pacific',
    flag: '🇦🇺',
    countryCodeAlpha3: 'AUS',
    center: [-27, 133],
  },
  {
    countryNameEn: 'Aruba',
    countryNameLocal: 'Aruba',
    countryCode: 'AW',
    currencyCode: 'AWG',
    currencyNameEn: 'Aruban florin',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '297',
    region: 'South/Latin America',
    flag: '🇦🇼',
    countryCodeAlpha3: 'ABW',
    center: [12.5, -69.9667],
  },
  {
    countryNameEn: 'Åland Islands',
    countryNameLocal: 'Åland',
    countryCode: 'AX',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'sv',
    officialLanguageNameEn: 'Swedish',
    officialLanguageNameLocal: 'Svenska',
    countryCallingCode: '358',
    region: 'Europe',
    flag: '🇦🇽',
    countryCodeAlpha3: 'ALA',
    center: [60.25, 19.91],
  },
  {
    countryNameEn: 'Azerbaijan',
    countryNameLocal: 'Azərbaycan',
    countryCode: 'AZ',
    currencyCode: 'AZN',
    currencyNameEn: 'Azerbaijani manat',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'az',
    officialLanguageNameEn: 'Azerbaijani',
    officialLanguageNameLocal: 'azərbaycan dili',
    countryCallingCode: '994',
    region: 'Asia & Pacific',
    flag: '🇦🇿',
    countryCodeAlpha3: 'AZE',
    center: [40.5, 47.5],
  },
  {
    countryNameEn: 'Bosnia and Herzegovina',
    countryNameLocal: 'Bosna i Hercegovina',
    countryCode: 'BA',
    currencyCode: 'BAM',
    currencyNameEn: 'Bosnia and Herzegovina convertible mark',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'bs',
    officialLanguageNameEn: 'Bosnian',
    officialLanguageNameLocal: 'bosanski jezik',
    countryCallingCode: '387',
    region: 'Europe',
    flag: '🇧🇦',
    countryCodeAlpha3: 'BIH',
    center: [44, 18],
  },
  {
    countryNameEn: 'Barbados',
    countryNameLocal: 'Barbados',
    countryCode: 'BB',
    currencyCode: 'BBD',
    currencyNameEn: 'Barbados dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1246',
    region: 'South/Latin America',
    flag: '🇧🇧',
    countryCodeAlpha3: 'BRB',
    center: [13.1667, -59.5333],
  },
  {
    countryNameEn: 'Bangladesh',
    countryNameLocal: 'গণপ্রজাতন্ত্রী বাংলাদেশ',
    countryCode: 'BD',
    currencyCode: 'BDT',
    currencyNameEn: 'Bangladeshi taka',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'bn',
    officialLanguageNameEn: 'Bengali',
    officialLanguageNameLocal: 'বাংলা',
    countryCallingCode: '880',
    region: 'Asia & Pacific',
    flag: '🇧🇩',
    countryCodeAlpha3: 'BGD',
    center: [24, 90],
  },
  {
    countryNameEn: 'Belgium',
    countryNameLocal: 'België, Belgique, Belgien',
    countryCode: 'BE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'n° TVABTW-nr Mwst-nr',
    tinName: 'BTW identificatienummer / Numéro de TVA',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '32',
    region: 'Europe',
    flag: '🇧🇪',
    countryCodeAlpha3: 'BEL',
    center: [50.8333, 4],
  },
  {
    countryNameEn: 'Burkina Faso',
    countryNameLocal: 'Burkina Faso',
    countryCode: 'BF',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '226',
    region: 'Africa',
    flag: '🇧🇫',
    countryCodeAlpha3: 'BFA',
    center: [13, -2],
  },
  {
    countryNameEn: 'Bulgaria',
    countryNameLocal: 'България',
    countryCode: 'BG',
    currencyCode: 'BGN',
    currencyNameEn: 'Bulgarian lev',
    tinType: 'ДДС номер',
    tinName: 'Идентификационен номер по ДДС',
    officialLanguageCode: 'bg',
    officialLanguageNameEn: 'Bulgarian',
    officialLanguageNameLocal: 'български език',
    countryCallingCode: '359',
    region: 'Europe',
    flag: '🇧🇬',
    countryCodeAlpha3: 'BGR',
    center: [43, 25],
  },
  {
    countryNameEn: 'Bahrain',
    countryNameLocal: 'البحرين',
    countryCode: 'BH',
    currencyCode: 'BHD',
    currencyNameEn: 'Bahraini dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '973',
    region: 'Arab States',
    flag: '🇧🇭',
    countryCodeAlpha3: 'BHR',
    center: [26, 50.55],
  },
  {
    countryNameEn: 'Burundi',
    countryNameLocal: 'Burundi',
    countryCode: 'BI',
    currencyCode: 'BIF',
    currencyNameEn: 'Burundian franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '257',
    region: 'Africa',
    flag: '🇧🇮',
    countryCodeAlpha3: 'BDI',
    center: [-3.5, 30],
  },
  {
    countryNameEn: 'Benin',
    countryNameLocal: 'Bénin',
    countryCode: 'BJ',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '229',
    region: 'Africa',
    flag: '🇧🇯',
    countryCodeAlpha3: 'BEN',
    center: [9.5, 2.25],
  },
  {
    countryNameEn: 'Saint Barthélemy',
    countryNameLocal: 'Saint-Barthélemy',
    countryCode: 'BL',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '590',
    region: 'South/Latin America',
    flag: '🇧🇱',
    countryCodeAlpha3: 'BLM',
    center: [17.89, -62.83],
  },
  {
    countryNameEn: 'Bermuda',
    countryNameLocal: 'Bermuda',
    countryCode: 'BM',
    currencyCode: 'BMD',
    currencyNameEn: 'Bermudian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1441',
    region: 'North America',
    flag: '🇧🇲',
    countryCodeAlpha3: 'BMU',
    center: [32.3333, -64.75],
  },
  {
    countryNameEn: 'Brunei Darussalam',
    countryNameLocal: 'Brunei Darussalam',
    countryCode: 'BN',
    currencyCode: 'BND',
    currencyNameEn: 'Brunei dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ms',
    officialLanguageNameEn: 'Malay',
    officialLanguageNameLocal: 'Bahasa Melayu, بهاس ملايو‎',
    countryCallingCode: '673',
    region: 'Asia & Pacific',
    flag: '🇧🇳',
    countryCodeAlpha3: 'BRN',
    center: [4.5, 114.6667],
  },
  {
    countryNameEn: 'Bolivia (Plurinational State of)',
    countryNameLocal: 'Bolivia, Bulibiya, Volívia, Wuliwya',
    countryCode: 'BO',
    currencyCode: 'BOP',
    currencyNameEn: '',
    tinType: 'NIT',
    tinName: 'Número de Identificación Tributaria',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '591',
    region: 'South/Latin America',
    flag: '🇧🇴',
    countryCodeAlpha3: 'BOL',
    center: [-17, -65],
  },
  {
    countryNameEn: 'Bonaire, Sint Eustatius and Saba',
    countryNameLocal: 'Caribisch Nederland',
    countryCode: 'BQ',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '5997',
    region: 'Unknown',
    flag: '🇧🇶',
    countryCodeAlpha3: 'BES',
    center: [12.16, -68.3],
  },
  {
    countryNameEn: 'Brazil',
    countryNameLocal: 'Brasil',
    countryCode: 'BR',
    currencyCode: 'BRL',
    currencyNameEn: 'Brazilian real',
    tinType: 'CNPJ',
    tinName: 'Cadastro Nacional de Pessoa Jurídica',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '55',
    region: 'South/Latin America',
    flag: '🇧🇷',
    countryCodeAlpha3: 'BRA',
    center: [-10, -55],
  },
  {
    countryNameEn: 'Bhutan',
    countryNameLocal: 'འབྲུག་ཡུལ',
    countryCode: 'BT',
    currencyCode: 'BTN',
    currencyNameEn: 'Bhutanese ngultrum',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'dz',
    officialLanguageNameEn: 'Dzongkha',
    officialLanguageNameLocal: 'རྫོང་ཁ',
    countryCallingCode: '975',
    region: 'Asia & Pacific',
    flag: '🇧🇹',
    countryCodeAlpha3: 'BTN',
    center: [27.5, 90.5],
  },
  {
    countryNameEn: 'Bouvet Island',
    countryNameLocal: 'Bouvetøya',
    countryCode: 'BV',
    currencyCode: 'NOK',
    currencyNameEn: 'Norwegian krone',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'no',
    officialLanguageNameEn: 'Norwegian',
    officialLanguageNameLocal: 'Norsk',
    countryCallingCode: '',
    region: 'South/Latin America',
    flag: '🇧🇻',
    countryCodeAlpha3: 'BVT',
    center: [-54.4333, 3.4],
  },
  {
    countryNameEn: 'Botswana',
    countryNameLocal: 'Botswana',
    countryCode: 'BW',
    currencyCode: 'BWP',
    currencyNameEn: 'Botswana pula',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '267',
    region: 'Africa',
    flag: '🇧🇼',
    countryCodeAlpha3: 'BWA',
    center: [-22, 24],
  },
  {
    countryNameEn: 'Belarus',
    countryNameLocal: 'Беларусь',
    countryCode: 'BY',
    currencyCode: 'BYR',
    currencyNameEn: '',
    tinType: 'УНП (UNP)',
    tinName: 'Учетный номер плательщика',
    officialLanguageCode: 'be',
    officialLanguageNameEn: 'Belarusian',
    officialLanguageNameLocal: 'беларуская мова',
    countryCallingCode: '375',
    region: 'Europe',
    flag: '🇧🇾',
    countryCodeAlpha3: 'BLR',
    center: [53, 28],
  },
  {
    countryNameEn: 'Belize',
    countryNameLocal: 'Belize',
    countryCode: 'BZ',
    currencyCode: 'BZD',
    currencyNameEn: 'Belize dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '501',
    region: 'South/Latin America',
    flag: '🇧🇿',
    countryCodeAlpha3: 'BLZ',
    center: [17.25, -88.75],
  },
  {
    countryNameEn: 'Canada',
    countryNameLocal: 'Canada',
    countryCode: 'CA',
    currencyCode: 'CAD',
    currencyNameEn: 'Canadian dollar',
    tinType: 'BN / NE',
    tinName: 'Business Number',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1',
    region: 'North America',
    flag: '🇨🇦',
    countryCodeAlpha3: 'CAN',
    center: [60, -95],
  },
  {
    countryNameEn: 'Switzerland',
    countryNameLocal: 'Schweiz, Suisse, Svizzera, Svizra',
    countryCode: 'CH',
    currencyCode: 'CHE',
    currencyNameEn: 'WIR Euro (complementary currency)',
    tinType: 'MWST/TVA/IVA',
    tinName: 'Mehrwertsteuernummer',
    officialLanguageCode: 'de',
    officialLanguageNameEn: 'German',
    officialLanguageNameLocal: 'Deutsch',
    countryCallingCode: '41',
    region: 'Europe',
    flag: '🇨🇭',
    countryCodeAlpha3: 'CHE',
    center: [47, 8],
  },
  {
    countryNameEn: "Côte d'Ivoire",
    countryNameLocal: "Côte d'Ivoire",
    countryCode: 'CI',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '',
    region: 'Africa',
    flag: '🇨🇮',
    countryCodeAlpha3: 'CIV',
    center: [8, -5],
  },
  {
    countryNameEn: 'Chile',
    countryNameLocal: 'Chile',
    countryCode: 'CL',
    currencyCode: 'CLP',
    currencyNameEn: 'Chilean peso',
    tinType: 'RUT',
    tinName: 'Rol Único Tributario',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '56',
    region: 'South/Latin America',
    flag: '🇨🇱',
    countryCodeAlpha3: 'CHL',
    center: [-30, -71],
  },
  {
    countryNameEn: 'Cameroon',
    countryNameLocal: 'Cameroun, Cameroon',
    countryCode: 'CM',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '237',
    region: 'Africa',
    flag: '🇨🇲',
    countryCodeAlpha3: 'CMR',
    center: [6, 12],
  },
  {
    countryNameEn: 'China',
    countryNameLocal: '中国',
    countryCode: 'CN',
    currencyCode: 'CNY',
    currencyNameEn: 'Renminbi (Chinese) yuan',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'zh-hans',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '86',
    region: 'Asia & Pacific',
    flag: '🇨🇳',
    countryCodeAlpha3: 'CHN',
    center: [35, 105],
  },
  {
    countryNameEn: 'Colombia',
    countryNameLocal: 'Colombia',
    countryCode: 'CO',
    currencyCode: 'COP',
    currencyNameEn: 'Colombian peso',
    tinType: 'NIT',
    tinName: 'Número De Identificación Tributaria',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '57',
    region: 'South/Latin America',
    flag: '🇨🇴',
    countryCodeAlpha3: 'COL',
    center: [4, -72],
  },
  {
    countryNameEn: 'Costa Rica',
    countryNameLocal: 'Costa Rica',
    countryCode: 'CR',
    currencyCode: 'CRC',
    currencyNameEn: 'Costa Rican colon',
    tinType: '',
    tinName: 'Cédula Jurídica',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '506',
    region: 'South/Latin America',
    flag: '🇨🇷',
    countryCodeAlpha3: 'CRI',
    center: [10, -84],
  },
  {
    countryNameEn: 'Cuba',
    countryNameLocal: 'Cuba',
    countryCode: 'CU',
    currencyCode: 'CUC',
    currencyNameEn: 'Cuban convertible peso',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '53',
    region: 'South/Latin America',
    flag: '🇨🇺',
    countryCodeAlpha3: 'CUB',
    center: [21.5, -80],
  },
  {
    countryNameEn: 'Cabo Verde',
    countryNameLocal: 'Cabo Verde',
    countryCode: 'CV',
    currencyCode: 'CVE',
    currencyNameEn: 'Cape Verdean escudo',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '',
    region: 'Africa',
    flag: '🇨🇻',
    countryCodeAlpha3: 'CPV',
    center: [16, -24],
  },
  {
    countryNameEn: 'Curaçao',
    countryNameLocal: 'Curaçao',
    countryCode: 'CW',
    currencyCode: 'ANG',
    currencyNameEn: 'Netherlands Antillean guilder',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '599',
    region: 'Unknown',
    flag: '🇨🇼',
    countryCodeAlpha3: 'CUW',
    center: [12.19, -68.97],
  },
  {
    countryNameEn: 'Christmas Island',
    countryNameLocal: 'Christmas Island',
    countryCode: 'CX',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '61',
    region: 'Asia & Pacific',
    flag: '🇨🇽',
    countryCodeAlpha3: 'CXR',
    center: [-10.5, 105.6667],
  },
  {
    countryNameEn: 'Cyprus',
    countryNameLocal: 'Κύπρος, Kibris',
    countryCode: 'CY',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'ΦΠΑ',
    tinName: 'Αριθμός Εγγραφής Φ.Π.Α.',
    officialLanguageCode: 'el',
    officialLanguageNameEn: 'Greek, Modern (1453-)',
    officialLanguageNameLocal: 'ελληνικά',
    countryCallingCode: '357',
    region: 'Europe',
    flag: '🇨🇾',
    countryCodeAlpha3: 'CYP',
    center: [35, 33],
  },
  {
    countryNameEn: 'Germany',
    countryNameLocal: 'Deutschland',
    countryCode: 'DE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'USt-IdNr.',
    tinName: 'Umsatzsteuer-Identifikationsnummer',
    officialLanguageCode: 'de',
    officialLanguageNameEn: 'German',
    officialLanguageNameLocal: 'Deutsch',
    countryCallingCode: '49',
    region: 'Europe',
    flag: '🇩🇪',
    countryCodeAlpha3: 'DEU',
    center: [51, 9],
  },
  {
    countryNameEn: 'Djibouti',
    countryNameLocal: 'Djibouti, جيبوتي, Jabuuti, Gabuutih',
    countryCode: 'DJ',
    currencyCode: 'DJF',
    currencyNameEn: 'Djiboutian franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '253',
    region: 'Arab States',
    flag: '🇩🇯',
    countryCodeAlpha3: 'DJI',
    center: [11.5, 43],
  },
  {
    countryNameEn: 'Denmark',
    countryNameLocal: 'Danmark',
    countryCode: 'DK',
    currencyCode: 'DKK',
    currencyNameEn: 'Danish krone',
    tinType: 'CVR',
    tinName: 'Momsregistreringsnummer',
    officialLanguageCode: 'da',
    officialLanguageNameEn: 'Danish',
    officialLanguageNameLocal: 'dansk',
    countryCallingCode: '45',
    region: 'Europe',
    flag: '🇩🇰',
    countryCodeAlpha3: 'DNK',
    center: [56, 10],
  },
  {
    countryNameEn: 'Dominica',
    countryNameLocal: 'Dominica',
    countryCode: 'DM',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '767',
    region: 'South/Latin America',
    flag: '🇩🇲',
    countryCodeAlpha3: 'DMA',
    center: [15.4167, -61.3333],
  },
  {
    countryNameEn: 'Algeria',
    countryNameLocal: 'الجزائر',
    countryCode: 'DZ',
    currencyCode: 'DZD',
    currencyNameEn: 'Algerian dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '213',
    region: 'Arab States',
    flag: '🇩🇿',
    countryCodeAlpha3: 'DZA',
    center: [28, 3],
  },
  {
    countryNameEn: 'Ecuador',
    countryNameLocal: 'Ecuador',
    countryCode: 'EC',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: 'RUC',
    tinName: 'Número de Registro Unico de Contribuyentes',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '593',
    region: 'South/Latin America',
    flag: '🇪🇨',
    countryCodeAlpha3: 'ECU',
    center: [-2, -77.5],
  },
  {
    countryNameEn: 'Estonia',
    countryNameLocal: 'Eesti',
    countryCode: 'EE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'KMKR',
    tinName: 'Käibemaksukohustuslase number',
    officialLanguageCode: 'et',
    officialLanguageNameEn: 'Estonian',
    officialLanguageNameLocal: 'eesti, eesti keel',
    countryCallingCode: '372',
    region: 'Europe',
    flag: '🇪🇪',
    countryCodeAlpha3: 'EST',
    center: [59, 26],
  },
  {
    countryNameEn: 'Egypt',
    countryNameLocal: 'مصر',
    countryCode: 'EG',
    currencyCode: 'EGP',
    currencyNameEn: 'Egyptian pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '20',
    region: 'Arab States',
    flag: '🇪🇬',
    countryCodeAlpha3: 'EGY',
    center: [27, 30],
  },
  {
    countryNameEn: 'Western Sahara',
    countryNameLocal: 'Sahara Occidental',
    countryCode: 'EH',
    currencyCode: 'MAD',
    currencyNameEn: 'Moroccan dirham',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '',
    region: 'Africa',
    flag: '🇪🇭',
    countryCodeAlpha3: 'ESH',
    center: [24.5, -13],
  },
  {
    countryNameEn: 'Eritrea',
    countryNameLocal: 'ኤርትራ, إرتريا, Eritrea',
    countryCode: 'ER',
    currencyCode: 'ERN',
    currencyNameEn: 'Eritrean nakfa',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ti',
    officialLanguageNameEn: 'Tigrinya',
    officialLanguageNameLocal: 'ትግርኛ',
    countryCallingCode: '291',
    region: 'Africa',
    flag: '🇪🇷',
    countryCodeAlpha3: 'ERI',
    center: [15, 39],
  },
  {
    countryNameEn: 'Spain',
    countryNameLocal: 'España',
    countryCode: 'ES',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'NIF (CIF)',
    tinName: 'Número de Identificación Fiscal (formerly named Código de Identificación Fiscal)',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '34',
    region: 'Europe',
    flag: '🇪🇸',
    countryCodeAlpha3: 'ESP',
    center: [40, -4],
  },
  {
    countryNameEn: 'Ethiopia',
    countryNameLocal: 'ኢትዮጵያ, Itoophiyaa',
    countryCode: 'ET',
    currencyCode: 'ETB',
    currencyNameEn: 'Ethiopian birr',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'am',
    officialLanguageNameEn: 'Amharic',
    officialLanguageNameLocal: 'አማርኛ',
    countryCallingCode: '251',
    region: 'Africa',
    flag: '🇪🇹',
    countryCodeAlpha3: 'ETH',
    center: [8, 38],
  },
  {
    countryNameEn: 'Finland',
    countryNameLocal: 'Suomi',
    countryCode: 'FI',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'ALV nro',
    tinName: 'Arvonlisäveronumero',
    officialLanguageCode: 'fi',
    officialLanguageNameEn: 'Finnish',
    officialLanguageNameLocal: 'suomi, suomen kieli',
    countryCallingCode: '358',
    region: 'Europe',
    flag: '🇫🇮',
    countryCodeAlpha3: 'FIN',
    center: [64, 26],
  },
  {
    countryNameEn: 'Fiji',
    countryNameLocal: 'Fiji',
    countryCode: 'FJ',
    currencyCode: 'FJD',
    currencyNameEn: 'Fiji dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '679',
    region: 'Asia & Pacific',
    flag: '🇫🇯',
    countryCodeAlpha3: 'FJI',
    center: [-18, 175],
  },
  {
    countryNameEn: 'Micronesia (Federated States of)',
    countryNameLocal: 'Micronesia',
    countryCode: 'FM',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '691',
    region: 'Asia & Pacific',
    flag: '🇫🇲',
    countryCodeAlpha3: 'FSM',
    center: [6.9167, 158.25],
  },
  {
    countryNameEn: 'France',
    countryNameLocal: 'France',
    countryCode: 'FR',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'n° TVA',
    tinName: "Numéro d'identification à la taxe sur la valeur ajoutée / Numéro de TVA intracommunautaire",
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '33',
    region: 'Europe',
    flag: '🇫🇷',
    countryCodeAlpha3: 'FRA',
    center: [46, 2],
  },
  {
    countryNameEn: 'Gabon',
    countryNameLocal: 'Gabon',
    countryCode: 'GA',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '241',
    region: 'Africa',
    flag: '🇬🇦',
    countryCodeAlpha3: 'GAB',
    center: [-1, 11.75],
  },
  {
    countryNameEn: 'Grenada',
    countryNameLocal: 'Grenada',
    countryCode: 'GD',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1473',
    region: 'South/Latin America',
    flag: '🇬🇩',
    countryCodeAlpha3: 'GRD',
    center: [12.1167, -61.6667],
  },
  {
    countryNameEn: 'Georgia',
    countryNameLocal: 'საქართველო',
    countryCode: 'GE',
    currencyCode: 'GEL',
    currencyNameEn: 'Georgian lari',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ka',
    officialLanguageNameEn: 'Georgian',
    officialLanguageNameLocal: 'ქართული',
    countryCallingCode: '995',
    region: 'Europe',
    flag: '🇬🇪',
    countryCodeAlpha3: 'GEO',
    center: [42, 43.5],
  },
  {
    countryNameEn: 'French Guiana',
    countryNameLocal: 'Guyane française',
    countryCode: 'GF',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '594',
    region: 'South/Latin America',
    flag: '🇬🇫',
    countryCodeAlpha3: 'GUF',
    center: [4, -53],
  },
  {
    countryNameEn: 'Guernsey',
    countryNameLocal: 'Guernsey',
    countryCode: 'GG',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇬🇬',
    countryCodeAlpha3: 'GGY',
    center: [49.5, -2.56],
  },
  {
    countryNameEn: 'Ghana',
    countryNameLocal: 'Ghana',
    countryCode: 'GH',
    currencyCode: 'GHS',
    currencyNameEn: 'Ghanaian cedi',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '233',
    region: 'Africa',
    flag: '🇬🇭',
    countryCodeAlpha3: 'GHA',
    center: [8, -2],
  },
  {
    countryNameEn: 'Gibraltar',
    countryNameLocal: 'Gibraltar',
    countryCode: 'GI',
    currencyCode: 'GIP',
    currencyNameEn: 'Gibraltar pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '350',
    region: 'Europe',
    flag: '🇬🇮',
    countryCodeAlpha3: 'GIB',
    center: [36.1833, -5.3667],
  },
  {
    countryNameEn: 'Greenland',
    countryNameLocal: 'Kalaallit Nunaat, Grønland',
    countryCode: 'GL',
    currencyCode: 'DKK',
    currencyNameEn: 'Danish krone',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'kl',
    officialLanguageNameEn: 'Kalaallisut, Greenlandic',
    officialLanguageNameLocal: 'kalaallisut, kalaallit oqaasii',
    countryCallingCode: '299',
    region: 'Europe',
    flag: '🇬🇱',
    countryCodeAlpha3: 'GRL',
    center: [72, -40],
  },
  {
    countryNameEn: 'Guinea',
    countryNameLocal: 'Guinée',
    countryCode: 'GN',
    currencyCode: 'GNF',
    currencyNameEn: 'Guinean franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '224',
    region: 'Africa',
    flag: '🇬🇳',
    countryCodeAlpha3: 'GIN',
    center: [11, -10],
  },
  {
    countryNameEn: 'Guadeloupe',
    countryNameLocal: 'Guadeloupe',
    countryCode: 'GP',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '590',
    region: 'South/Latin America',
    flag: '🇬🇵',
    countryCodeAlpha3: 'GLP',
    center: [16.25, -61.5833],
  },
  {
    countryNameEn: 'Equatorial Guinea',
    countryNameLocal: 'Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial',
    countryCode: 'GQ',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '240',
    region: 'Africa',
    flag: '🇬🇶',
    countryCodeAlpha3: 'GNQ',
    center: [2, 10],
  },
  {
    countryNameEn: 'Greece',
    countryNameLocal: 'Ελλάδα',
    countryCode: 'GR',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'el',
    officialLanguageNameEn: 'Greek, Modern (1453-)',
    officialLanguageNameLocal: 'ελληνικά',
    countryCallingCode: '30',
    region: 'Europe',
    flag: '🇬🇷',
    countryCodeAlpha3: 'GRC',
    center: [39, 22],
  },
  {
    countryNameEn: 'South Georgia and the South Sandwich Islands',
    countryNameLocal: 'South Georgia and the South Sandwich Islands',
    countryCode: 'GS',
    currencyCode: 'FKP',
    currencyNameEn: 'Falkland Islands pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '500',
    region: 'South/Latin America',
    flag: '🇬🇸',
    countryCodeAlpha3: 'SGS',
    center: [-54.5, -37],
  },
  {
    countryNameEn: 'Guatemala',
    countryNameLocal: 'Guatemala',
    countryCode: 'GT',
    currencyCode: 'GTQ',
    currencyNameEn: 'Guatemalan quetzal',
    tinType: 'NIT',
    tinName: 'Número de Identificación Tributaria',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '502',
    region: 'South/Latin America',
    flag: '🇬🇹',
    countryCodeAlpha3: 'GTM',
    center: [15.5, -90.25],
  },
  {
    countryNameEn: 'Guam',
    countryNameLocal: 'Guam, Guåhån',
    countryCode: 'GU',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1',
    region: 'Asia & Pacific',
    flag: '🇬🇺',
    countryCodeAlpha3: 'GUM',
    center: [13.4667, 144.7833],
  },
  {
    countryNameEn: 'Guinea-Bissau',
    countryNameLocal: 'Guiné-Bissau',
    countryCode: 'GW',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '245',
    region: 'Africa',
    flag: '🇬🇼',
    countryCodeAlpha3: 'GNB',
    center: [12, -15],
  },
  {
    countryNameEn: 'Guyana',
    countryNameLocal: 'Guyana',
    countryCode: 'GY',
    currencyCode: 'GYD',
    currencyNameEn: 'Guyanese dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '592',
    region: 'South/Latin America',
    flag: '🇬🇾',
    countryCodeAlpha3: 'GUY',
    center: [5, -59],
  },
  {
    countryNameEn: 'Hong Kong',
    countryNameLocal: '香港, Hong Kong',
    countryCode: 'HK',
    currencyCode: 'HKD',
    currencyNameEn: 'Hong Kong dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'zh-hant',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '852',
    region: 'Asia & Pacific',
    flag: '🇭🇰',
    countryCodeAlpha3: 'HKG',
    center: [22.25, 114.1667],
  },
  {
    countryNameEn: 'Honduras',
    countryNameLocal: 'Honduras',
    countryCode: 'HN',
    currencyCode: 'HNL',
    currencyNameEn: 'Honduran lempira',
    tinType: 'RTN',
    tinName: 'Registro Tributario Nacional',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '504',
    region: 'South/Latin America',
    flag: '🇭🇳',
    countryCodeAlpha3: 'HND',
    center: [15, -86.5],
  },
  {
    countryNameEn: 'Croatia',
    countryNameLocal: 'Hrvatska',
    countryCode: 'HR',
    currencyCode: 'HRK',
    currencyNameEn: 'Croatian kuna',
    tinType: 'PDV-ID; OIB',
    tinName: 'PDV Id. Broj OIB',
    officialLanguageCode: 'hr',
    officialLanguageNameEn: 'Croatian',
    officialLanguageNameLocal: 'hrvatski jezik',
    countryCallingCode: '385',
    region: 'Europe',
    flag: '🇭🇷',
    countryCodeAlpha3: 'HRV',
    center: [45.1667, 15.5],
  },
  {
    countryNameEn: 'Haiti',
    countryNameLocal: 'Haïti, Ayiti',
    countryCode: 'HT',
    currencyCode: 'HTG',
    currencyNameEn: 'Haitian gourde',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '509',
    region: 'South/Latin America',
    flag: '🇭🇹',
    countryCodeAlpha3: 'HTI',
    center: [19, -72.4167],
  },
  {
    countryNameEn: 'Hungary',
    countryNameLocal: 'Magyarország',
    countryCode: 'HU',
    currencyCode: 'HUF',
    currencyNameEn: 'Hungarian forint',
    tinType: 'ANUM',
    tinName: 'Közösségi adószám',
    officialLanguageCode: 'hu',
    officialLanguageNameEn: 'Hungarian',
    officialLanguageNameLocal: 'magyar',
    countryCallingCode: '36',
    region: 'Europe',
    flag: '🇭🇺',
    countryCodeAlpha3: 'HUN',
    center: [47, 20],
  },
  {
    countryNameEn: 'Indonesia',
    countryNameLocal: 'Indonesia',
    countryCode: 'ID',
    currencyCode: 'IDR',
    currencyNameEn: 'Indonesian rupiah',
    tinType: 'NPWP',
    tinName: 'Nomor Pokok Wajib Pajak',
    officialLanguageCode: 'id',
    officialLanguageNameEn: 'Indonesian',
    officialLanguageNameLocal: 'Bahasa Indonesia',
    countryCallingCode: '62',
    region: 'Asia & Pacific',
    flag: '🇮🇩',
    countryCodeAlpha3: 'IDN',
    center: [-5, 120],
  },
  {
    countryNameEn: 'Ireland',
    countryNameLocal: 'Ireland, Éire',
    countryCode: 'IE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'VAT or CBL',
    tinName: 'Value added tax identification no.',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '353',
    region: 'Europe',
    flag: '🇮🇪',
    countryCodeAlpha3: 'IRL',
    center: [53, -8],
  },
  {
    countryNameEn: 'Israel',
    countryNameLocal: 'ישראל',
    countryCode: 'IL',
    currencyCode: 'ILS',
    currencyNameEn: 'Israeli new shekel',
    tinType: '',
    tinName: 'מס\' עוסק מורשה / ח"פ',
    officialLanguageCode: 'he',
    officialLanguageNameEn: 'Hebrew',
    officialLanguageNameLocal: 'עברית',
    countryCallingCode: '972',
    region: 'Europe',
    flag: '🇮🇱',
    countryCodeAlpha3: 'ISR',
    center: [31.5, 34.75],
  },
  {
    countryNameEn: 'Isle of Man',
    countryNameLocal: 'Isle of Man',
    countryCode: 'IM',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇮🇲',
    countryCodeAlpha3: 'IMN',
    center: [54.23, -4.55],
  },
  {
    countryNameEn: 'India',
    countryNameLocal: 'भारत, India',
    countryCode: 'IN',
    currencyCode: 'INR',
    currencyNameEn: 'Indian rupee',
    tinType: 'VAT TIN / CST TIN',
    tinName:
      'Value Added Tax - Taxpayer Identification Number / Central Sales Tax - Taxpayer Identification Number (In most states)Not applicable',
    officialLanguageCode: 'hi',
    officialLanguageNameEn: 'Hindi',
    officialLanguageNameLocal: 'हिन्दी, हिंदी',
    countryCallingCode: '91',
    region: 'Asia & Pacific',
    flag: '🇮🇳',
    countryCodeAlpha3: 'IND',
    center: [20, 77],
  },
  {
    countryNameEn: 'Iraq',
    countryNameLocal: 'العراق, Iraq',
    countryCode: 'IQ',
    currencyCode: 'IQD',
    currencyNameEn: 'Iraqi dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '964',
    region: 'Arab States',
    flag: '🇮🇶',
    countryCodeAlpha3: 'IRQ',
    center: [33, 44],
  },
  {
    countryNameEn: 'Iran (Islamic Republic of)',
    countryNameLocal: 'ایران',
    countryCode: 'IR',
    currencyCode: 'IRR',
    currencyNameEn: 'Iranian rial',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fa',
    officialLanguageNameEn: 'Persian',
    officialLanguageNameLocal: 'فارسی',
    countryCallingCode: '98',
    region: 'Asia & Pacific',
    flag: '🇮🇷',
    countryCodeAlpha3: 'IRN',
    center: [32, 53],
  },
  {
    countryNameEn: 'Iceland',
    countryNameLocal: 'Ísland',
    countryCode: 'IS',
    currencyCode: 'ISK',
    currencyNameEn: 'Icelandic króna',
    tinType: 'VSK / VASK',
    tinName: 'Virðisaukaskattsnúmer',
    officialLanguageCode: 'is',
    officialLanguageNameEn: 'Icelandic',
    officialLanguageNameLocal: 'Íslenska',
    countryCallingCode: '354',
    region: 'Europe',
    flag: '🇮🇸',
    countryCodeAlpha3: 'ISL',
    center: [65, -18],
  },
  {
    countryNameEn: 'Italy',
    countryNameLocal: 'Italia',
    countryCode: 'IT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'P.IVA',
    tinName: 'Partita IVA(IVA = Imposta sul Valore Aggiunto)',
    officialLanguageCode: 'it',
    officialLanguageNameEn: 'Italian',
    officialLanguageNameLocal: 'Italiano',
    countryCallingCode: '39',
    region: 'Europe',
    flag: '🇮🇹',
    countryCodeAlpha3: 'ITA',
    center: [42.8333, 12.8333],
  },
  {
    countryNameEn: 'Jersey',
    countryNameLocal: 'Jersey',
    countryCode: 'JE',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇯🇪',
    countryCodeAlpha3: 'JEY',
    center: [49.21, -2.13],
  },
  {
    countryNameEn: 'Jamaica',
    countryNameLocal: 'Jamaica',
    countryCode: 'JM',
    currencyCode: 'JMD',
    currencyNameEn: 'Jamaican dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '876',
    region: 'South/Latin America',
    flag: '🇯🇲',
    countryCodeAlpha3: 'JAM',
    center: [18.25, -77.5],
  },
  {
    countryNameEn: 'Jordan',
    countryNameLocal: 'الأُرْدُن',
    countryCode: 'JO',
    currencyCode: 'JOD',
    currencyNameEn: 'Jordanian dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '962',
    region: 'Arab States',
    flag: '🇯🇴',
    countryCodeAlpha3: 'JOR',
    center: [31, 36],
  },
  {
    countryNameEn: 'Japan',
    countryNameLocal: '日本',
    countryCode: 'JP',
    currencyCode: 'JPY',
    currencyNameEn: 'Japanese yen',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ja',
    officialLanguageNameEn: 'Japanese',
    officialLanguageNameLocal: '日本語 (にほんご)',
    countryCallingCode: '81',
    region: 'Asia & Pacific',
    flag: '🇯🇵',
    countryCodeAlpha3: 'JPN',
    center: [36, 138],
  },
  {
    countryNameEn: 'Kenya',
    countryNameLocal: 'Kenya',
    countryCode: 'KE',
    currencyCode: 'KES',
    currencyNameEn: 'Kenyan shilling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'sw',
    officialLanguageNameEn: 'Swahili',
    officialLanguageNameLocal: 'Kiswahili',
    countryCallingCode: '254',
    region: 'Africa',
    flag: '🇰🇪',
    countryCodeAlpha3: 'KEN',
    center: [1, 38],
  },
  {
    countryNameEn: 'Kyrgyzstan',
    countryNameLocal: 'Кыргызстан, Киргизия',
    countryCode: 'KG',
    currencyCode: 'KGS',
    currencyNameEn: 'Kyrgyzstani som',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ky',
    officialLanguageNameEn: 'Kirghiz, Kyrgyz',
    officialLanguageNameLocal: 'Кыргызча, Кыргыз тили',
    countryCallingCode: '996',
    region: 'Asia & Pacific',
    flag: '🇰🇬',
    countryCodeAlpha3: 'KGZ',
    center: [41, 75],
  },
  {
    countryNameEn: 'Cambodia',
    countryNameLocal: 'កម្ពុជា',
    countryCode: 'KH',
    currencyCode: 'KHR',
    currencyNameEn: 'Cambodian riel',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'km',
    officialLanguageNameEn: 'Central Khmer',
    officialLanguageNameLocal: 'ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ',
    countryCallingCode: '855',
    region: 'Asia & Pacific',
    flag: '🇰🇭',
    countryCodeAlpha3: 'KHM',
    center: [13, 105],
  },
  {
    countryNameEn: 'North Korea',
    countryNameLocal: '조선민주주의인민공화국',
    countryCode: 'KP',
    currencyCode: 'KPW',
    currencyNameEn: 'North Korean won',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ko',
    officialLanguageNameEn: 'Korean',
    officialLanguageNameLocal: '조선어',
    countryCallingCode: '850',
    region: 'Asia',
    flag: '🇰🇵',
    countryCodeAlpha3: 'PRK',
    center: [40, 127],
  },
  {
    countryNameEn: 'South Korea',
    countryNameLocal: '대한민국',
    countryCode: 'KR',
    currencyCode: 'KRW',
    currencyNameEn: 'South Korean won',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ko',
    officialLanguageNameEn: 'Korean',
    officialLanguageNameLocal: '한국어',
    countryCallingCode: '82',
    region: 'Asia',
    flag: '🇰🇷',
    countryCodeAlpha3: 'KOR',
    center: [37, 127.5],
  },
  {
    countryNameEn: 'Kiribati',
    countryNameLocal: 'Kiribati',
    countryCode: 'KI',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '686',
    region: 'Asia & Pacific',
    flag: '🇰🇮',
    countryCodeAlpha3: 'KIR',
    center: [1.4167, 173],
  },
  {
    countryNameEn: 'Saint Kitts and Nevis',
    countryNameLocal: 'Saint Kitts and Nevis',
    countryCode: 'KN',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1869',
    region: 'South/Latin America',
    flag: '🇰🇳',
    countryCodeAlpha3: 'KNA',
    center: [17.3333, -62.75],
  },
  {
    countryNameEn: 'Kuwait',
    countryNameLocal: 'الكويت',
    countryCode: 'KW',
    currencyCode: 'KWD',
    currencyNameEn: 'Kuwaiti dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '965',
    region: 'Arab States',
    flag: '🇰🇼',
    countryCodeAlpha3: 'KWT',
    center: [29.3375, 47.6581],
  },
  {
    countryNameEn: 'Kazakhstan',
    countryNameLocal: 'Қазақстан, Казахстан',
    countryCode: 'KZ',
    currencyCode: 'KZT',
    currencyNameEn: 'Kazakhstani tenge',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'kk',
    officialLanguageNameEn: 'Kazakh',
    officialLanguageNameLocal: 'қазақ тілі',
    countryCallingCode: '7',
    region: 'Asia & Pacific',
    flag: '🇰🇿',
    countryCodeAlpha3: 'KAZ',
    center: [48, 68],
  },
  {
    countryNameEn: 'Lebanon',
    countryNameLocal: 'لبنان, Liban',
    countryCode: 'LB',
    currencyCode: 'LBP',
    currencyNameEn: 'Lebanese pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '961',
    region: 'Arab States',
    flag: '🇱🇧',
    countryCodeAlpha3: 'LBN',
    center: [33.8333, 35.8333],
  },
  {
    countryNameEn: 'Saint Lucia',
    countryNameLocal: 'Saint Lucia',
    countryCode: 'LC',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1758',
    region: 'South/Latin America',
    flag: '🇱🇨',
    countryCodeAlpha3: 'LCA',
    center: [13.8833, -61.1333],
  },
  {
    countryNameEn: 'Liechtenstein',
    countryNameLocal: 'Liechtenstein',
    countryCode: 'LI',
    currencyCode: 'CHF',
    currencyNameEn: 'Swiss franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'de',
    officialLanguageNameEn: 'German',
    officialLanguageNameLocal: 'Deutsch',
    countryCallingCode: '423',
    region: 'Europe',
    flag: '🇱🇮',
    countryCodeAlpha3: 'LIE',
    center: [47.1667, 9.5333],
  },
  {
    countryNameEn: 'Sri Lanka',
    countryNameLocal: 'ශ්‍රී ලංකා, இலங்கை',
    countryCode: 'LK',
    currencyCode: 'LKR',
    currencyNameEn: 'Sri Lankan rupee',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'si',
    officialLanguageNameEn: 'Sinhala, Sinhalese',
    officialLanguageNameLocal: 'සිංහල',
    countryCallingCode: '94',
    region: 'Asia & Pacific',
    flag: '🇱🇰',
    countryCodeAlpha3: 'LKA',
    center: [7, 81],
  },
  {
    countryNameEn: 'Liberia',
    countryNameLocal: 'Liberia',
    countryCode: 'LR',
    currencyCode: 'LRD',
    currencyNameEn: 'Liberian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '231',
    region: 'Africa',
    flag: '🇱🇷',
    countryCodeAlpha3: 'LBR',
    center: [6.5, -9.5],
  },
  {
    countryNameEn: 'Lesotho',
    countryNameLocal: 'Lesotho',
    countryCode: 'LS',
    currencyCode: 'LSL',
    currencyNameEn: 'Lesotho loti',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '266',
    region: 'Africa',
    flag: '🇱🇸',
    countryCodeAlpha3: 'LSO',
    center: [-29.5, 28.5],
  },
  {
    countryNameEn: 'Lithuania',
    countryNameLocal: 'Lietuva',
    countryCode: 'LT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'PVM kodas',
    tinName: 'PVM (abbrev. Pridėtinės vertės mokestis) mokėtojo kodas',
    officialLanguageCode: 'lt',
    officialLanguageNameEn: 'Lithuanian',
    officialLanguageNameLocal: 'lietuvių kalba',
    countryCallingCode: '370',
    region: 'Europe',
    flag: '🇱🇹',
    countryCodeAlpha3: 'LTU',
    center: [56, 24],
  },
  {
    countryNameEn: 'Luxembourg',
    countryNameLocal: 'Lëtzebuerg, Luxembourg, Luxemburg',
    countryCode: 'LU',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'No. TVA',
    tinName: "Numéro d'identification à la taxe sur la valeur ajoutée",
    officialLanguageCode: 'lb',
    officialLanguageNameEn: 'Luxembourgish, Letzeburgesch',
    officialLanguageNameLocal: 'Lëtzebuergesch',
    countryCallingCode: '352',
    region: 'Europe',
    flag: '🇱🇺',
    countryCodeAlpha3: 'LUX',
    center: [49.75, 6.1667],
  },
  {
    countryNameEn: 'Latvia',
    countryNameLocal: 'Latvija',
    countryCode: 'LV',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'PVN',
    tinName: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs',
    officialLanguageCode: 'lv',
    officialLanguageNameEn: 'Latvian',
    officialLanguageNameLocal: 'latviešu valoda',
    countryCallingCode: '371',
    region: 'Europe',
    flag: '🇱🇻',
    countryCodeAlpha3: 'LVA',
    center: [57, 25],
  },
  {
    countryNameEn: 'Libya',
    countryNameLocal: 'ليبيا',
    countryCode: 'LY',
    currencyCode: 'LYD',
    currencyNameEn: 'Libyan dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '218',
    region: 'Arab States',
    flag: '🇱🇾',
    countryCodeAlpha3: 'LBY',
    center: [25, 17],
  },
  {
    countryNameEn: 'Morocco',
    countryNameLocal: 'Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب',
    countryCode: 'MA',
    currencyCode: 'MAD',
    currencyNameEn: 'Moroccan dirham',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '212',
    region: 'Arab States',
    flag: '🇲🇦',
    countryCodeAlpha3: 'MAR',
    center: [32, -5],
  },
  {
    countryNameEn: 'Monaco',
    countryNameLocal: 'Monaco',
    countryCode: 'MC',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '377',
    region: 'Europe',
    flag: '🇲🇨',
    countryCodeAlpha3: 'MCO',
    center: [43.7333, 7.4],
  },
  {
    countryNameEn: 'Montenegro',
    countryNameLocal: 'Crna Gora, Црна Гора',
    countryCode: 'ME',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'srp',
    officialLanguageNameEn: 'српски језик',
    officialLanguageNameLocal: '',
    countryCallingCode: '382',
    region: 'Europe',
    flag: '🇲🇪',
    countryCodeAlpha3: 'MNE',
    center: [42, 19],
  },
  {
    countryNameEn: 'Saint Martin (French part)',
    countryNameLocal: 'Saint-Martin',
    countryCode: 'MF',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '590',
    region: 'South/Latin America',
    flag: '🇲🇫',
    countryCodeAlpha3: 'MAF',
    center: [18.06, -63.06],
  },
  {
    countryNameEn: 'Madagascar',
    countryNameLocal: 'Madagasikara, Madagascar',
    countryCode: 'MG',
    currencyCode: 'MGA',
    currencyNameEn: 'Malagasy ariary',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'mg',
    officialLanguageNameEn: 'Malagasy',
    officialLanguageNameLocal: 'fiteny malagasy',
    countryCallingCode: '261',
    region: 'Africa',
    flag: '🇲🇬',
    countryCodeAlpha3: 'MDG',
    center: [-20, 47],
  },
  {
    countryNameEn: 'Mali',
    countryNameLocal: 'Mali',
    countryCode: 'ML',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '223',
    region: 'Africa',
    flag: '🇲🇱',
    countryCodeAlpha3: 'MLI',
    center: [17, -4],
  },
  {
    countryNameEn: 'Myanmar',
    countryNameLocal: 'မြန်မာ',
    countryCode: 'MM',
    currencyCode: 'MMK',
    currencyNameEn: 'Myanmar kyat',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'my',
    officialLanguageNameEn: 'Burmese',
    officialLanguageNameLocal: 'ဗမာစာ',
    countryCallingCode: '95',
    region: 'Asia & Pacific',
    flag: '🇲🇲',
    countryCodeAlpha3: 'MMR',
    center: [22, 98],
  },
  {
    countryNameEn: 'Mongolia',
    countryNameLocal: 'Монгол Улс',
    countryCode: 'MN',
    currencyCode: 'MNT',
    currencyNameEn: 'Mongolian tögrög',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'mn',
    officialLanguageNameEn: 'Mongolian',
    officialLanguageNameLocal: 'Монгол хэл',
    countryCallingCode: '976',
    region: 'Asia & Pacific',
    flag: '🇲🇳',
    countryCodeAlpha3: 'MNG',
    center: [46, 105],
  },
  {
    countryNameEn: 'Macao',
    countryNameLocal: '澳門, Macau',
    countryCode: 'MO',
    currencyCode: 'MOP',
    currencyNameEn: 'Macanese pataca',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'zh-hant',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '',
    region: 'Asia & Pacific',
    flag: '🇲🇴',
    countryCodeAlpha3: 'MAC',
    center: [22.1667, 113.55],
  },
  {
    countryNameEn: 'Martinique',
    countryNameLocal: 'Martinique',
    countryCode: 'MQ',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '596',
    region: 'South/Latin America',
    flag: '🇲🇶',
    countryCodeAlpha3: 'MTQ',
    center: [14.6667, -61],
  },
  {
    countryNameEn: 'Mauritania',
    countryNameLocal: 'موريتانيا, Mauritanie',
    countryCode: 'MR',
    currencyCode: 'MRU',
    currencyNameEn: '',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '222',
    region: 'Arab States',
    flag: '🇲🇷',
    countryCodeAlpha3: 'MRT',
    center: [20, -12],
  },
  {
    countryNameEn: 'Montserrat',
    countryNameLocal: 'Montserrat',
    countryCode: 'MS',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1664',
    region: 'South/Latin America',
    flag: '🇲🇸',
    countryCodeAlpha3: 'MSR',
    center: [16.75, -62.2],
  },
  {
    countryNameEn: 'Malta',
    countryNameLocal: 'Malta',
    countryCode: 'MT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'Vat No.',
    tinName: 'Vat reg. no.',
    officialLanguageCode: 'mt',
    officialLanguageNameEn: 'Maltese',
    officialLanguageNameLocal: 'Malti',
    countryCallingCode: '356',
    region: 'Europe',
    flag: '🇲🇹',
    countryCodeAlpha3: 'MLT',
    center: [35.8333, 14.5833],
  },
  {
    countryNameEn: 'Mauritius',
    countryNameLocal: 'Maurice, Mauritius',
    countryCode: 'MU',
    currencyCode: 'MUR',
    currencyNameEn: 'Mauritian rupee',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'mfe',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '230',
    region: 'Africa',
    flag: '🇲🇺',
    countryCodeAlpha3: 'MUS',
    center: [-20.2833, 57.55],
  },
  {
    countryNameEn: 'Maldives',
    countryNameLocal: '',
    countryCode: 'MV',
    currencyCode: 'MVR',
    currencyNameEn: 'Maldivian rufiyaa',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'dv',
    officialLanguageNameEn: 'Divehi, Dhivehi, Maldivian',
    officialLanguageNameLocal: 'ދިވެހި',
    countryCallingCode: '960',
    region: 'Asia & Pacific',
    flag: '🇲🇻',
    countryCodeAlpha3: 'MDV',
    center: [3.25, 73],
  },
  {
    countryNameEn: 'Malawi',
    countryNameLocal: 'Malawi',
    countryCode: 'MW',
    currencyCode: 'MWK',
    currencyNameEn: 'Malawian kwacha',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '265',
    region: 'Africa',
    flag: '🇲🇼',
    countryCodeAlpha3: 'MWI',
    center: [-13.5, 34],
  },
  {
    countryNameEn: 'Mexico',
    countryNameLocal: 'México',
    countryCode: 'MX',
    currencyCode: 'MXN',
    currencyNameEn: 'Mexican peso',
    tinType: 'RFC',
    tinName: 'Registro Federal de Contribuyentes',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '52',
    region: 'South/Latin America',
    flag: '🇲🇽',
    countryCodeAlpha3: 'MEX',
    center: [23, -102],
  },
  {
    countryNameEn: 'Malaysia',
    countryNameLocal: '',
    countryCode: 'MY',
    currencyCode: 'MYR',
    currencyNameEn: 'Malaysian ringgit',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ms',
    officialLanguageNameEn: 'Malay',
    officialLanguageNameLocal: 'Bahasa Melayu, بهاس ملايو‎',
    countryCallingCode: '60',
    region: 'Asia & Pacific',
    flag: '🇲🇾',
    countryCodeAlpha3: 'MYS',
    center: [2.5, 112.5],
  },
  {
    countryNameEn: 'Mozambique',
    countryNameLocal: 'Mozambique',
    countryCode: 'MZ',
    currencyCode: 'MZN',
    currencyNameEn: 'Mozambican metical',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '258',
    region: 'Africa',
    flag: '🇲🇿',
    countryCodeAlpha3: 'MOZ',
    center: [-18.25, 35],
  },
  {
    countryNameEn: 'Namibia',
    countryNameLocal: 'Namibia',
    countryCode: 'NA',
    currencyCode: 'NAD',
    currencyNameEn: 'Namibian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '264',
    region: 'Africa',
    flag: '🇳🇦',
    countryCodeAlpha3: 'NAM',
    center: [-22, 17],
  },
  {
    countryNameEn: 'New Caledonia',
    countryNameLocal: 'Nouvelle-Calédonie',
    countryCode: 'NC',
    currencyCode: 'XPF',
    currencyNameEn: 'CFP franc (franc Pacifique)',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '687',
    region: 'Asia & Pacific',
    flag: '🇳🇨',
    countryCodeAlpha3: 'NCL',
    center: [-21.5, 165.5],
  },
  {
    countryNameEn: 'Norfolk Island',
    countryNameLocal: 'Norfolk Island',
    countryCode: 'NF',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '672',
    region: 'Asia & Pacific',
    flag: '🇳🇫',
    countryCodeAlpha3: 'NFK',
    center: [-29.0333, 167.95],
  },
  {
    countryNameEn: 'Nigeria',
    countryNameLocal: 'Nigeria',
    countryCode: 'NG',
    currencyCode: 'NGN',
    currencyNameEn: 'Nigerian naira',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '234',
    region: 'Africa',
    flag: '🇳🇬',
    countryCodeAlpha3: 'NGA',
    center: [10, 8],
  },
  {
    countryNameEn: 'Nicaragua',
    countryNameLocal: 'Nicaragua',
    countryCode: 'NI',
    currencyCode: 'NIO',
    currencyNameEn: 'Nicaraguan córdoba',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '505',
    region: 'South/Latin America',
    flag: '🇳🇮',
    countryCodeAlpha3: 'NIC',
    center: [13, -85],
  },
  {
    countryNameEn: 'Norway',
    countryNameLocal: 'Norge, Noreg',
    countryCode: 'NO',
    currencyCode: 'NOK',
    currencyNameEn: 'Norwegian krone',
    tinType: 'Orgnr',
    tinName: 'Organisasjonsnummer',
    officialLanguageCode: 'nb',
    officialLanguageNameEn: 'Norwegian Bokmål',
    officialLanguageNameLocal: 'Norsk Bokmål',
    countryCallingCode: '47',
    region: 'Europe',
    flag: '🇳🇴',
    countryCodeAlpha3: 'NOR',
    center: [62, 10],
  },
  {
    countryNameEn: 'Nepal',
    countryNameLocal: '',
    countryCode: 'NP',
    currencyCode: 'NPR',
    currencyNameEn: 'Nepalese rupee',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ne',
    officialLanguageNameEn: 'Nepali',
    officialLanguageNameLocal: 'नेपाली',
    countryCallingCode: '977',
    region: 'Asia & Pacific',
    flag: '🇳🇵',
    countryCodeAlpha3: 'NPL',
    center: [28, 84],
  },
  {
    countryNameEn: 'Nauru',
    countryNameLocal: 'Nauru',
    countryCode: 'NR',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'na',
    officialLanguageNameEn: 'Nauru',
    officialLanguageNameLocal: 'Dorerin Naoero',
    countryCallingCode: '674',
    region: 'Asia & Pacific',
    flag: '🇳🇷',
    countryCodeAlpha3: 'NRU',
    center: [-0.5333, 166.9167],
  },
  {
    countryNameEn: 'Niue',
    countryNameLocal: 'Niue',
    countryCode: 'NU',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'niu',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '683',
    region: 'Asia & Pacific',
    flag: '🇳🇺',
    countryCodeAlpha3: 'NIU',
    center: [-19.0333, -169.8667],
  },
  {
    countryNameEn: 'New Zealand',
    countryNameLocal: 'New Zealand',
    countryCode: 'NZ',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: 'NZBN',
    tinName: 'NZ Business Number',
    officialLanguageCode: 'mi',
    officialLanguageNameEn: 'Maori',
    officialLanguageNameLocal: 'te reo Māori',
    countryCallingCode: '64',
    region: 'Asia & Pacific',
    flag: '🇳🇿',
    countryCodeAlpha3: 'NZL',
    center: [-41, 174],
  },
  {
    countryNameEn: 'Oman',
    countryNameLocal: 'سلطنة عُمان',
    countryCode: 'OM',
    currencyCode: 'OMR',
    currencyNameEn: 'Omani rial',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '968',
    region: 'Arab States',
    flag: '🇴🇲',
    countryCodeAlpha3: 'OMN',
    center: [21, 57],
  },
  {
    countryNameEn: 'Panama',
    countryNameLocal: 'Panama',
    countryCode: 'PA',
    currencyCode: 'PAB',
    currencyNameEn: 'Panamanian balboa',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '507',
    region: 'South/Latin America',
    flag: '🇵🇦',
    countryCodeAlpha3: 'PAN',
    center: [9, -80],
  },
  {
    countryNameEn: 'Peru',
    countryNameLocal: 'Perú',
    countryCode: 'PE',
    currencyCode: 'PEN',
    currencyNameEn: 'Peruvian sol',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '51',
    region: 'South/Latin America',
    flag: '🇵🇪',
    countryCodeAlpha3: 'PER',
    center: [-10, -76],
  },
  {
    countryNameEn: 'French Polynesia',
    countryNameLocal: 'Polynésie française',
    countryCode: 'PF',
    currencyCode: 'XPF',
    currencyNameEn: 'CFP franc (franc Pacifique)',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '689',
    region: 'Asia & Pacific',
    flag: '🇵🇫',
    countryCodeAlpha3: 'PYF',
    center: [-15, -140],
  },
  {
    countryNameEn: 'Papua New Guinea',
    countryNameLocal: 'Papua New Guinea',
    countryCode: 'PG',
    currencyCode: 'PGK',
    currencyNameEn: 'Papua New Guinean kina',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '675',
    region: 'Asia & Pacific',
    flag: '🇵🇬',
    countryCodeAlpha3: 'PNG',
    center: [-6, 147],
  },
  {
    countryNameEn: 'Pakistan',
    countryNameLocal: 'پاکستان',
    countryCode: 'PK',
    currencyCode: 'PKR',
    currencyNameEn: 'Pakistani rupee',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '92',
    region: 'Asia & Pacific',
    flag: '🇵🇰',
    countryCodeAlpha3: 'PAK',
    center: [30, 70],
  },
  {
    countryNameEn: 'Poland',
    countryNameLocal: 'Polska',
    countryCode: 'PL',
    currencyCode: 'PLN',
    currencyNameEn: 'Polish złoty',
    tinType: 'NIP',
    tinName: 'numer identyfikacji podatkowej',
    officialLanguageCode: 'pl',
    officialLanguageNameEn: 'Polish',
    officialLanguageNameLocal: 'język polski, polszczyzna',
    countryCallingCode: '48',
    region: 'Europe',
    flag: '🇵🇱',
    countryCodeAlpha3: 'POL',
    center: [52, 20],
  },
  {
    countryNameEn: 'Saint Pierre and Miquelon',
    countryNameLocal: 'Saint-Pierre-et-Miquelon',
    countryCode: 'PM',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '508',
    region: 'North America',
    flag: '🇵🇲',
    countryCodeAlpha3: 'SPM',
    center: [46.8333, -56.3333],
  },
  {
    countryNameEn: 'Pitcairn',
    countryNameLocal: 'Pitcairn',
    countryCode: 'PN',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '64',
    region: 'Asia & Pacific',
    flag: '🇵🇳',
    countryCodeAlpha3: 'PCN',
    center: [-24.7, -127.4],
  },
  {
    countryNameEn: 'Puerto Rico',
    countryNameLocal: 'Puerto Rico',
    countryCode: 'PR',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '1',
    region: 'South/Latin America',
    flag: '🇵🇷',
    countryCodeAlpha3: 'PRI',
    center: [18.25, -66.5],
  },
  {
    countryNameEn: 'State of Palestine',
    countryNameLocal: 'Palestinian Territory',
    countryCode: 'PS',
    currencyCode: 'ILS',
    currencyNameEn: 'Israeli new shekel',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '970',
    region: 'Arab States',
    flag: '🇵🇸',
    countryCodeAlpha3: 'PSE',
    center: [32, 35.25],
  },
  {
    countryNameEn: 'Portugal',
    countryNameLocal: 'Portugal',
    countryCode: 'PT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'NIPC',
    tinName: 'Número de Identificação de Pessoa Coletiva (NIPC)',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '351',
    region: 'Europe',
    flag: '🇵🇹',
    countryCodeAlpha3: 'PRT',
    center: [39.5, -8],
  },
  {
    countryNameEn: 'Palau',
    countryNameLocal: 'Palau',
    countryCode: 'PW',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '680',
    region: 'Asia & Pacific',
    flag: '🇵🇼',
    countryCodeAlpha3: 'PLW',
    center: [7.5, 134.5],
  },
  {
    countryNameEn: 'Paraguay',
    countryNameLocal: 'Paraguay',
    countryCode: 'PY',
    currencyCode: 'PYG',
    currencyNameEn: 'Paraguayan guaraní',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '595',
    region: 'South/Latin America',
    flag: '🇵🇾',
    countryCodeAlpha3: 'PRY',
    center: [-23, -58],
  },
  {
    countryNameEn: 'Qatar',
    countryNameLocal: 'قطر',
    countryCode: 'QA',
    currencyCode: 'QAR',
    currencyNameEn: 'Qatari riyal',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '974',
    region: 'Arab States',
    flag: '🇶🇦',
    countryCodeAlpha3: 'QAT',
    center: [25.5, 51.25],
  },
  {
    countryNameEn: 'Réunion',
    countryNameLocal: 'La Réunion',
    countryCode: 'RE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '262',
    region: 'Asia & Pacific',
    flag: '🇷🇪',
    countryCodeAlpha3: 'REU',
    center: [-21.1, 55.6],
  },
  {
    countryNameEn: 'Romania',
    countryNameLocal: 'România',
    countryCode: 'RO',
    currencyCode: 'RON',
    currencyNameEn: 'Romanian leu',
    tinType: 'CIF',
    tinName: 'Codul de identificare fiscală',
    officialLanguageCode: 'ro',
    officialLanguageNameEn: 'Romanian, Moldavian, Moldovan',
    officialLanguageNameLocal: 'Română',
    countryCallingCode: '40',
    region: 'Europe',
    flag: '🇷🇴',
    countryCodeAlpha3: 'ROU',
    center: [46, 25],
  },
  {
    countryNameEn: 'Serbia',
    countryNameLocal: 'Србија',
    countryCode: 'RS',
    currencyCode: 'RSD',
    currencyNameEn: 'Serbian dinar',
    tinType: 'PIB',
    tinName: 'Poreski identifikacioni broj',
    officialLanguageCode: 'sr',
    officialLanguageNameEn: 'Serbian',
    officialLanguageNameLocal: 'српски језик',
    countryCallingCode: '381',
    region: 'Europe',
    flag: '🇷🇸',
    countryCodeAlpha3: 'SRB',
    center: [44, 21],
  },
  {
    countryNameEn: 'Russia',
    countryNameLocal: 'Россия',
    countryCode: 'RU',
    currencyCode: 'RUB',
    currencyNameEn: 'Russian ruble',
    tinType: 'ИНН',
    tinName: 'Идентификационный номер налогоплательщика',
    officialLanguageCode: 'ru',
    officialLanguageNameEn: 'Russian',
    officialLanguageNameLocal: 'русский',
    countryCallingCode: '7',
    region: 'Europe',
    flag: '🇷🇺',
    countryCodeAlpha3: 'RUS',
    center: [60, 100],
  },
  {
    countryNameEn: 'Rwanda',
    countryNameLocal: 'Rwanda',
    countryCode: 'RW',
    currencyCode: 'RWF',
    currencyNameEn: 'Rwandan franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'rw',
    officialLanguageNameEn: 'Kinyarwanda',
    officialLanguageNameLocal: 'Ikinyarwanda',
    countryCallingCode: '250',
    region: 'Africa',
    flag: '🇷🇼',
    countryCodeAlpha3: 'RWA',
    center: [-2, 30],
  },
  {
    countryNameEn: 'Saudi Arabia',
    countryNameLocal: 'السعودية',
    countryCode: 'SA',
    currencyCode: 'SAR',
    currencyNameEn: 'Saudi riyal',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '966',
    region: 'Arab States',
    flag: '🇸🇦',
    countryCodeAlpha3: 'SAU',
    center: [25, 45],
  },
  {
    countryNameEn: 'Solomon Islands',
    countryNameLocal: 'Solomon Islands',
    countryCode: 'SB',
    currencyCode: 'SBD',
    currencyNameEn: 'Solomon Islands dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '677',
    region: 'Asia & Pacific',
    flag: '🇸🇧',
    countryCodeAlpha3: 'SLB',
    center: [-8, 159],
  },
  {
    countryNameEn: 'Seychelles',
    countryNameLocal: 'Seychelles',
    countryCode: 'SC',
    currencyCode: 'SCR',
    currencyNameEn: 'Seychelles rupee',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '248',
    region: 'Africa',
    flag: '🇸🇨',
    countryCodeAlpha3: 'SYC',
    center: [-4.5833, 55.6667],
  },
  {
    countryNameEn: 'Sweden',
    countryNameLocal: 'Sverige',
    countryCode: 'SE',
    currencyCode: 'SEK',
    currencyNameEn: 'Swedish krona/kronor',
    tinType: 'Momsnr.',
    tinName: 'VAT-nummer',
    officialLanguageCode: 'sv',
    officialLanguageNameEn: 'Swedish',
    officialLanguageNameLocal: 'Svenska',
    countryCallingCode: '46',
    region: 'Europe',
    flag: '🇸🇪',
    countryCodeAlpha3: 'SWE',
    center: [62, 15],
  },
  {
    countryNameEn: 'Singapore',
    countryNameLocal: 'Singapore',
    countryCode: 'SG',
    currencyCode: 'SGD',
    currencyNameEn: 'Singapore dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'zh-hans',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '65',
    region: 'Asia & Pacific',
    flag: '🇸🇬',
    countryCodeAlpha3: 'SGP',
    center: [1.3667, 103.8],
  },
  {
    countryNameEn: 'Saint Helena, Ascension and Tristan da Cunha',
    countryNameLocal: 'Saint Helena',
    countryCode: 'SH',
    currencyCode: 'SHP',
    currencyNameEn: 'Saint Helena pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '290',
    region: 'Africa',
    flag: '🇸🇭',
    countryCodeAlpha3: 'SHN',
    center: [-15.9333, -5.7],
  },
  {
    countryNameEn: 'Slovenia',
    countryNameLocal: 'Slovenija',
    countryCode: 'SI',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'ID za DDV',
    tinName: 'Davčna številka',
    officialLanguageCode: 'sl',
    officialLanguageNameEn: 'Slovenian',
    officialLanguageNameLocal: 'Slovenski Jezik, Slovenščina',
    countryCallingCode: '386',
    region: 'Europe',
    flag: '🇸🇮',
    countryCodeAlpha3: 'SVN',
    center: [46, 15],
  },
  {
    countryNameEn: 'Svalbard and Jan Mayen',
    countryNameLocal: 'Svalbard and Jan Mayen',
    countryCode: 'SJ',
    currencyCode: 'NOK',
    currencyNameEn: 'Norwegian krone',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'no',
    officialLanguageNameEn: 'Norwegian',
    officialLanguageNameLocal: 'Norsk',
    countryCallingCode: '4779',
    region: 'Europe',
    flag: '🇸🇯',
    countryCodeAlpha3: 'SJM',
    center: [78, 20],
  },
  {
    countryNameEn: 'Slovakia',
    countryNameLocal: 'Slovensko',
    countryCode: 'SK',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'IČ DPH',
    tinName: 'Identifikačné číslo pre daň z pridanej hodnoty',
    officialLanguageCode: 'sk',
    officialLanguageNameEn: 'Slovak',
    officialLanguageNameLocal: 'Slovenčina, Slovenský Jazyk',
    countryCallingCode: '421',
    region: 'Europe',
    flag: '🇸🇰',
    countryCodeAlpha3: 'SVK',
    center: [48.6667, 19.5],
  },
  {
    countryNameEn: 'Sierra Leone',
    countryNameLocal: 'Sierra Leone',
    countryCode: 'SL',
    currencyCode: 'SLL',
    currencyNameEn: 'Sierra Leonean leone',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '232',
    region: 'Africa',
    flag: '🇸🇱',
    countryCodeAlpha3: 'SLE',
    center: [8.5, -11.5],
  },
  {
    countryNameEn: 'San Marino',
    countryNameLocal: 'San Marino',
    countryCode: 'SM',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'C.O.E.',
    tinName: 'Codice operatore economico',
    officialLanguageCode: 'it',
    officialLanguageNameEn: 'Italian',
    officialLanguageNameLocal: 'Italiano',
    countryCallingCode: '378',
    region: 'Europe',
    flag: '🇸🇲',
    countryCodeAlpha3: 'SMR',
    center: [43.7667, 12.4167],
  },
  {
    countryNameEn: 'Senegal',
    countryNameLocal: 'Sénégal',
    countryCode: 'SN',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '221',
    region: 'Africa',
    flag: '🇸🇳',
    countryCodeAlpha3: 'SEN',
    center: [14, -14],
  },
  {
    countryNameEn: 'Somalia',
    countryNameLocal: 'Somalia, الصومال',
    countryCode: 'SO',
    currencyCode: 'SOS',
    currencyNameEn: 'Somali shilling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'so',
    officialLanguageNameEn: 'Somali',
    officialLanguageNameLocal: 'Soomaaliga, af Soomaali',
    countryCallingCode: '252',
    region: 'Arab States',
    flag: '🇸🇴',
    countryCodeAlpha3: 'SOM',
    center: [10, 49],
  },
  {
    countryNameEn: 'Suriname',
    countryNameLocal: 'Suriname',
    countryCode: 'SR',
    currencyCode: 'SRD',
    currencyNameEn: 'Surinamese dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '597',
    region: 'South/Latin America',
    flag: '🇸🇷',
    countryCodeAlpha3: 'SUR',
    center: [4, -56],
  },
  {
    countryNameEn: 'South Sudan',
    countryNameLocal: 'South Sudan',
    countryCode: 'SS',
    currencyCode: 'SSP',
    currencyNameEn: 'South Sudanese pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '211',
    region: 'Africa',
    flag: '🇸🇸',
    countryCodeAlpha3: 'SDS',
  },
  {
    countryNameEn: 'Sao Tome and Principe',
    countryNameLocal: 'São Tomé e Príncipe',
    countryCode: 'ST',
    currencyCode: 'STN',
    currencyNameEn: '',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '239',
    region: 'Africa',
    flag: '🇸🇹',
    countryCodeAlpha3: 'STP',
    center: [1, 7],
  },
  {
    countryNameEn: 'El Salvador',
    countryNameLocal: 'El Salvador',
    countryCode: 'SV',
    currencyCode: 'SVC',
    currencyNameEn: 'Salvadoran colón',
    tinType: 'NIT',
    tinName: 'Número de Identificación Tributaria',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '503',
    region: 'South/Latin America',
    flag: '🇸🇻',
    countryCodeAlpha3: 'SLV',
    center: [13.8333, -88.9167],
  },
  {
    countryNameEn: 'Sint Maarten (Dutch part)',
    countryNameLocal: 'Sint Maarten',
    countryCode: 'SX',
    currencyCode: 'ANG',
    currencyNameEn: 'Netherlands Antillean guilder',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '1721',
    region: 'Unknown',
    flag: '🇸🇽',
    countryCodeAlpha3: 'SXM',
    center: [18.06, -63.06],
  },
  {
    countryNameEn: 'Syrian Arab Republic',
    countryNameLocal: 'سوريا, Sūriyya',
    countryCode: 'SY',
    currencyCode: 'SYP',
    currencyNameEn: 'Syrian pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '',
    region: 'Asia & Pacific',
    flag: '🇸🇾',
    countryCodeAlpha3: 'SYR',
    center: [35, 38],
  },
  {
    countryNameEn: 'Chad',
    countryNameLocal: 'Tchad, تشاد',
    countryCode: 'TD',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '235',
    region: 'Africa',
    flag: '🇹🇩',
    countryCodeAlpha3: 'TCD',
    center: [15, 19],
  },
  {
    countryNameEn: 'Togo',
    countryNameLocal: 'Togo',
    countryCode: 'TG',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '228',
    region: 'Africa',
    flag: '🇹🇬',
    countryCodeAlpha3: 'TGO',
    center: [8, 1.1667],
  },
  {
    countryNameEn: 'Thailand',
    countryNameLocal: 'ประเทศไทย',
    countryCode: 'TH',
    currencyCode: 'THB',
    currencyNameEn: 'Thai baht',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'th',
    officialLanguageNameEn: 'Thai',
    officialLanguageNameLocal: 'ไทย',
    countryCallingCode: '66',
    region: 'Asia & Pacific',
    flag: '🇹🇭',
    countryCodeAlpha3: 'THA',
    center: [15, 100],
  },
  {
    countryNameEn: 'Tajikistan',
    countryNameLocal: ',',
    countryCode: 'TJ',
    currencyCode: 'TJS',
    currencyNameEn: 'Tajikistani somoni',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'tg',
    officialLanguageNameEn: 'Tajik',
    officialLanguageNameLocal: 'тоҷикӣ, toçikī, تاجیکی‎',
    countryCallingCode: '992',
    region: 'Asia & Pacific',
    flag: '🇹🇯',
    countryCodeAlpha3: 'TJK',
    center: [39, 71],
  },
  {
    countryNameEn: 'Tokelau',
    countryNameLocal: 'Tokelau',
    countryCode: 'TK',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'tkl',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '690',
    region: 'Asia & Pacific',
    flag: '🇹🇰',
    countryCodeAlpha3: 'TKL',
    center: [-9, -172],
  },
  {
    countryNameEn: 'Timor-Leste',
    countryNameLocal: "Timor-Leste, Timor Lorosa'e",
    countryCode: 'TL',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'pt',
    officialLanguageNameEn: 'Portuguese',
    officialLanguageNameLocal: 'Português',
    countryCallingCode: '',
    region: 'Asia & Pacific',
    flag: '🇹🇱',
    countryCodeAlpha3: 'TLS',
    center: [-8.55, 125.5167],
  },
  {
    countryNameEn: 'Turkmenistan',
    countryNameLocal: 'Türkmenistan',
    countryCode: 'TM',
    currencyCode: 'TMT',
    currencyNameEn: 'Turkmenistan manat',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'tk',
    officialLanguageNameEn: 'Turkmen',
    officialLanguageNameLocal: 'Türkmen, Түркмен',
    countryCallingCode: '993',
    region: 'Asia & Pacific',
    flag: '🇹🇲',
    countryCodeAlpha3: 'TKM',
    center: [40, 60],
  },
  {
    countryNameEn: 'Tunisia',
    countryNameLocal: 'تونس, Tunisie',
    countryCode: 'TN',
    currencyCode: 'TND',
    currencyNameEn: 'Tunisian dinar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '216',
    region: 'Arab States',
    flag: '🇹🇳',
    countryCodeAlpha3: 'TUN',
    center: [34, 9],
  },
  {
    countryNameEn: 'Tonga',
    countryNameLocal: 'Tonga',
    countryCode: 'TO',
    currencyCode: 'TOP',
    currencyNameEn: 'Tongan paʻanga',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '676',
    region: 'Asia & Pacific',
    flag: '🇹🇴',
    countryCodeAlpha3: 'TON',
    center: [-20, -175],
  },
  {
    countryNameEn: 'Turkey',
    countryNameLocal: 'Türkiye',
    countryCode: 'TR',
    currencyCode: 'TRY',
    currencyNameEn: 'Turkish lira',
    tinType: 'KDV',
    tinName: 'Vergi Kimlik Numarası',
    officialLanguageCode: 'tr',
    officialLanguageNameEn: 'Turkish',
    officialLanguageNameLocal: 'Türkçe',
    countryCallingCode: '90',
    region: 'Europe',
    flag: '🇹🇷',
    countryCodeAlpha3: 'TUR',
    center: [39, 35],
  },
  {
    countryNameEn: 'Trinidad and Tobago',
    countryNameLocal: 'Trinidad and Tobago',
    countryCode: 'TT',
    currencyCode: 'TTD',
    currencyNameEn: 'Trinidad and Tobago dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '868',
    region: 'South/Latin America',
    flag: '🇹🇹',
    countryCodeAlpha3: 'TTO',
    center: [11, -61],
  },
  {
    countryNameEn: 'Tuvalu',
    countryNameLocal: 'Tuvalu',
    countryCode: 'TV',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '688',
    region: 'Asia & Pacific',
    flag: '🇹🇻',
    countryCodeAlpha3: 'TUV',
    center: [-8, 178],
  },
  {
    countryNameEn: 'United Republic of Tanzania',
    countryNameLocal: 'Tanzania',
    countryCode: 'TZ',
    currencyCode: 'TZS',
    currencyNameEn: 'Tanzanian shilling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'sw',
    officialLanguageNameEn: 'Swahili',
    officialLanguageNameLocal: 'Kiswahili',
    countryCallingCode: '255',
    region: 'Africa',
    flag: '🇹🇿',
    countryCodeAlpha3: 'TZA',
    center: [-6, 35],
  },
  {
    countryNameEn: 'Ukraine',
    countryNameLocal: 'Україна',
    countryCode: 'UA',
    currencyCode: 'UAH',
    currencyNameEn: 'Ukrainian hryvnia',
    tinType: 'ІНПП',
    tinName: 'Ідентифікаційний номер платника податків',
    officialLanguageCode: 'uk',
    officialLanguageNameEn: 'Ukrainian',
    officialLanguageNameLocal: 'Українська',
    countryCallingCode: '380',
    region: 'Europe',
    flag: '🇺🇦',
    countryCodeAlpha3: 'UKR',
    center: [49, 32],
  },
  {
    countryNameEn: 'Uganda',
    countryNameLocal: 'Uganda',
    countryCode: 'UG',
    currencyCode: 'UGX',
    currencyNameEn: 'Ugandan shilling',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '256',
    region: 'Africa',
    flag: '🇺🇬',
    countryCodeAlpha3: 'UGA',
    center: [1, 32],
  },
  {
    countryNameEn: 'United States of America',
    countryNameLocal: 'United States of America',
    countryCode: 'US',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: 'TIN',
    tinName: 'Tax Identification Number',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1',
    region: 'North America',
    flag: '🇺🇸',
    countryCodeAlpha3: 'USA',
    center: [38, -97],
  },
  {
    countryNameEn: 'Uruguay',
    countryNameLocal: 'Uruguay',
    countryCode: 'UY',
    currencyCode: 'UYU',
    currencyNameEn: 'Uruguayan peso',
    tinType: 'RUT',
    tinName: 'Registro Único Tributario',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '598',
    region: 'South/Latin America',
    flag: '🇺🇾',
    countryCodeAlpha3: 'URY',
    center: [-33, -56],
  },
  {
    countryNameEn: 'Uzbekistan',
    countryNameLocal: '',
    countryCode: 'UZ',
    currencyCode: 'UZS',
    currencyNameEn: 'Uzbekistan som',
    tinType: 'СТИР',
    tinName: 'Солиқ тўловчиларнинг идентификация рақами',
    officialLanguageCode: 'uz',
    officialLanguageNameEn: 'Uzbek',
    officialLanguageNameLocal: 'Oʻzbek, Ўзбек, أۇزبېك‎',
    countryCallingCode: '998',
    region: 'Asia & Pacific',
    flag: '🇺🇿',
    countryCodeAlpha3: 'UZB',
    center: [41, 64],
  },
  {
    countryNameEn: 'Saint Vincent and the Grenadines',
    countryNameLocal: 'Saint Vincent and the Grenadines',
    countryCode: 'VC',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1784',
    region: 'South/Latin America',
    flag: '🇻🇨',
    countryCodeAlpha3: 'VCT',
    center: [13.25, -61.2],
  },
  {
    countryNameEn: 'Venezuela (Bolivarian Republic of)',
    countryNameLocal: 'Venezuela',
    countryCode: 'VE',
    currencyCode: 'VES',
    currencyNameEn: '',
    tinType: 'RIF',
    tinName: 'Registro de Informacion Fiscal',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '58',
    region: 'South/Latin America',
    flag: '🇻🇪',
    countryCodeAlpha3: 'VEN',
    center: [8, -66],
  },
  {
    countryNameEn: 'Virgin Islands (British)',
    countryNameLocal: 'British Virgin Islands',
    countryCode: 'VG',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1284',
    region: 'South/Latin America',
    flag: '🇻🇬',
    countryCodeAlpha3: 'VGB',
    center: [18.5, -64.5],
  },
  {
    countryNameEn: 'Virgin Islands (U.S.)',
    countryNameLocal: 'United States Virgin Islands',
    countryCode: 'VI',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1340',
    region: 'South/Latin America',
    flag: '🇻🇮',
    countryCodeAlpha3: 'VIR',
    center: [18.3333, -64.8333],
  },
  {
    countryNameEn: 'Vietnam',
    countryNameLocal: 'Việt Nam',
    countryCode: 'VN',
    currencyCode: 'VND',
    currencyNameEn: 'Vietnamese đồng',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'vi',
    officialLanguageNameEn: 'Vietnamese',
    officialLanguageNameLocal: 'Tiếng Việt',
    countryCallingCode: '84',
    region: 'Asia & Pacific',
    flag: '🇻🇳',
    countryCodeAlpha3: 'VNM',
    center: [16, 106],
  },
  {
    countryNameEn: 'Vanuatu',
    countryNameLocal: 'Vanuatu',
    countryCode: 'VU',
    currencyCode: 'VUV',
    currencyNameEn: 'Vanuatu vatu',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'bi',
    officialLanguageNameEn: 'Bislama',
    officialLanguageNameLocal: 'Bislama',
    countryCallingCode: '678',
    region: 'Asia & Pacific',
    flag: '🇻🇺',
    countryCodeAlpha3: 'VUT',
    center: [-16, 167],
  },
  {
    countryNameEn: 'Wallis and Futuna',
    countryNameLocal: 'Wallis-et-Futuna',
    countryCode: 'WF',
    currencyCode: 'XPF',
    currencyNameEn: 'CFP franc (franc Pacifique)',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '681',
    region: 'Asia & Pacific',
    flag: '🇼🇫',
    countryCodeAlpha3: 'WLF',
    center: [-13.3, -176.2],
  },
  {
    countryNameEn: 'Samoa',
    countryNameLocal: 'Samoa',
    countryCode: 'WS',
    currencyCode: 'WST',
    currencyNameEn: 'Samoan tala',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'sm',
    officialLanguageNameEn: 'Samoan',
    officialLanguageNameLocal: "gagana fa'a Samoa",
    countryCallingCode: '685',
    region: 'Asia & Pacific',
    flag: '🇼🇸',
    countryCodeAlpha3: 'WSM',
    center: [-13.5833, -172.3333],
  },
  {
    countryNameEn: 'Yemen',
    countryNameLocal: 'اليَمَن',
    countryCode: 'YE',
    currencyCode: 'YER',
    currencyNameEn: 'Yemeni rial',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '967',
    region: 'Arab States',
    flag: '🇾🇪',
    countryCodeAlpha3: 'YEM',
    center: [15, 48],
  },
  {
    countryNameEn: 'Mayotte',
    countryNameLocal: 'Mayotte',
    countryCode: 'YT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '262',
    region: 'Africa',
    flag: '🇾🇹',
    countryCodeAlpha3: 'MYT',
    center: [-12.8333, 45.1667],
  },
  {
    countryNameEn: 'South Africa',
    countryNameLocal: 'South Africa',
    countryCode: 'ZA',
    currencyCode: 'ZAR',
    currencyNameEn: 'South African rand',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '27',
    region: 'Africa',
    flag: '🇿🇦',
    countryCodeAlpha3: 'ZAF',
    center: [-29, 24],
  },
  {
    countryNameEn: 'Zambia',
    countryNameLocal: 'Zambia',
    countryCode: 'ZM',
    currencyCode: 'ZMW',
    currencyNameEn: 'Zambian kwacha',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '260',
    region: 'Africa',
    flag: '🇿🇲',
    countryCodeAlpha3: 'ZMB',
    center: [-15, 30],
  },
  {
    countryNameEn: 'Zimbabwe',
    countryNameLocal: 'Zimbabwe',
    countryCode: 'ZW',
    currencyCode: 'ZWL',
    currencyNameEn: 'Zimbabwean dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '263',
    region: 'Africa',
    flag: '🇿🇼',
    countryCodeAlpha3: 'ZWE',
    center: [-20, 30],
  },
  {
    countryNameEn: 'Eswatini',
    countryNameLocal: 'Swaziland',
    countryCode: 'SZ',
    currencyCode: 'SZL',
    currencyNameEn: 'Swazi lilangeni',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '268',
    region: 'Africa',
    flag: '🇸🇿',
    countryCodeAlpha3: 'SWZ',
    center: [-26.5, 31.5],
  },
  {
    countryNameEn: 'North Macedonia',
    countryNameLocal: 'Македонија',
    countryCode: 'MK',
    currencyCode: 'MKD',
    currencyNameEn: 'Macedonian denar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'mk',
    officialLanguageNameEn: 'Macedonian',
    officialLanguageNameLocal: 'македонски јазик',
    countryCallingCode: '389',
    region: 'Europe',
    flag: '🇲🇰',
    countryCodeAlpha3: 'MKD',
    center: [41.8333, 22],
  },
  {
    countryNameEn: 'Philippines',
    countryNameLocal: 'Philippines',
    countryCode: 'PH',
    currencyCode: 'PHP',
    currencyNameEn: 'Philippine peso',
    tinType: 'TIN',
    tinName: 'Tax Identification Number',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '63',
    region: 'Asia & Pacific',
    flag: '🇵🇭',
    countryCodeAlpha3: 'PHL',
    center: [13, 122],
  },
  {
    countryNameEn: 'Netherlands',
    countryNameLocal: 'Nederland',
    countryCode: 'NL',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'Btw-nr.',
    tinName: 'Btw-nummer',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '31',
    region: 'Europe',
    flag: '🇳🇱',
    countryCodeAlpha3: 'NLD',
    center: [52.5, 5.75],
  },
  {
    countryNameEn: 'United Arab Emirates',
    countryNameLocal: 'دولة الإمارات العربيّة المتّحدة',
    countryCode: 'AE',
    currencyCode: 'AED',
    currencyNameEn: 'United Arab Emirates dirham',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '971',
    region: 'Arab States',
    flag: '🇦🇪',
    countryCodeAlpha3: 'ARE',
    center: [24, 54],
  },
  {
    countryNameEn: 'Republic of Moldova',
    countryNameLocal: 'Moldova, Молдавия',
    countryCode: 'MD',
    currencyCode: 'MDL',
    currencyNameEn: 'Moldovan leu',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ro',
    officialLanguageNameEn: 'Romanian, Moldavian, Moldovan',
    officialLanguageNameLocal: 'Română',
    countryCallingCode: '373',
    region: 'Europe',
    flag: '🇲🇩',
    countryCodeAlpha3: 'MDA',
    center: [47, 29],
  },
  {
    countryNameEn: 'Gambia',
    countryNameLocal: 'The Gambia',
    countryCode: 'GM',
    currencyCode: 'GMD',
    currencyNameEn: 'Gambian dalasi',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '220',
    region: 'Africa',
    flag: '🇬🇲',
    countryCodeAlpha3: 'GMB',
    center: [13.4667, -16.5667],
  },
  {
    countryNameEn: 'Dominican Republic',
    countryNameLocal: 'República Dominicana',
    countryCode: 'DO',
    currencyCode: 'DOP',
    currencyNameEn: 'Dominican peso',
    tinType: 'RNC',
    tinName: 'Registro Nacional del Contribuyente',
    officialLanguageCode: 'es',
    officialLanguageNameEn: 'Spanish, Castilian',
    officialLanguageNameLocal: 'Español',
    countryCallingCode: '1',
    region: 'South/Latin America',
    flag: '🇩🇴',
    countryCodeAlpha3: 'DOM',
    center: [19, -70.6667],
  },
  {
    countryNameEn: 'Sudan',
    countryNameLocal: 'السودان',
    countryCode: 'SD',
    currencyCode: 'SDG',
    currencyNameEn: 'Sudanese pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'ar',
    officialLanguageNameEn: 'Arabic',
    officialLanguageNameLocal: 'العربية',
    countryCallingCode: '249',
    region: 'Arab States',
    flag: '🇸🇩',
    countryCodeAlpha3: 'SDN',
    center: [15, 30],
  },
  {
    countryNameEn: "Lao People's Democratic Republic",
    countryNameLocal: 'ປະຊາຊົນລາວ',
    countryCode: 'LA',
    currencyCode: 'LAK',
    currencyNameEn: 'Lao kip',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'lo',
    officialLanguageNameEn: 'Lao',
    officialLanguageNameLocal: 'ພາສາລາວ',
    countryCallingCode: '',
    region: 'Asia & Pacific',
    flag: '🇱🇦',
    countryCodeAlpha3: 'LAO',
    center: [18, 105],
  },
  {
    countryNameEn: 'Taiwan (Province of China)',
    countryNameLocal: 'Taiwan (Province of China)',
    countryCode: 'TW',
    currencyCode: 'TWD',
    currencyNameEn: 'New Taiwan dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'zh-hant',
    officialLanguageNameEn: '',
    officialLanguageNameLocal: '',
    countryCallingCode: '886',
    region: 'Asia & Pacific',
    flag: '🇹🇼',
    countryCodeAlpha3: 'TWN',
    center: [23.5, 121],
  },
  {
    countryNameEn: 'Republic of the Congo',
    countryNameLocal: 'République du Congo',
    countryCode: 'CG',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '242',
    region: 'Africa',
    flag: '🇨🇬',
    countryCodeAlpha3: 'COG',
    center: [-1, 15],
  },
  {
    countryNameEn: 'Czechia',
    countryNameLocal: 'Česká republika',
    countryCode: 'CZ',
    currencyCode: 'CZK',
    currencyNameEn: 'Czech koruna',
    tinType: 'DIČ',
    tinName: 'Daňové identifikační číslo',
    officialLanguageCode: 'cs',
    officialLanguageNameEn: 'Czech',
    officialLanguageNameLocal: 'Čeština',
    countryCallingCode: '420',
    region: 'Europe',
    flag: '🇨🇿',
    countryCodeAlpha3: 'CZE',
    center: [49.75, 15.5],
  },
  {
    countryNameEn: 'United Kingdom',
    countryNameLocal: 'Great Britain',
    countryCode: 'GB',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: 'VAT Reg No',
    tinName: 'Value added tax registration number',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇬🇧',
    countryCodeAlpha3: 'GBR',
    center: [54, -2],
  },
  {
    countryNameEn: 'Niger',
    countryNameLocal: 'Niger',
    countryCode: 'NE',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '227',
    region: 'Africa',
    flag: '🇳🇪',
    countryCodeAlpha3: 'NER',
    center: [16, 8],
  },
  {
    countryNameEn: 'Democratic Republic of the Congo',
    countryNameLocal: 'Democratic Republic of the Congo',
    countryCode: 'CD',
    currencyCode: 'CDF',
    currencyNameEn: 'Congolese franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '243',
    region: 'Africa',
    flag: '🇨🇩',
    countryCodeAlpha3: 'COD',
    center: [0, 25],
  },
  {
    countryNameEn: 'Commonwealth of The Bahamas',
    countryNameLocal: 'Commonwealth of The Bahamas',
    countryCode: 'BS',
    currencyCode: 'BSD',
    currencyNameEn: 'Bahamian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1 242',
    region: 'Caribbean',
    flag: '🇧🇸',
    countryCodeAlpha3: 'BHS',
    center: [24.25, -76],
  },
  {
    countryNameEn: 'Cocos (Keeling) Islands',
    countryNameLocal: 'Pulu Kokos (Keeling)',
    countryCode: 'CC',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '61 891',
    region: 'Australia',
    flag: '🇨🇨',
    countryCodeAlpha3: 'CCK',
    center: [-12.5, 96.8333],
  },
  {
    countryNameEn: 'Central African Republic',
    countryNameLocal: 'République centrafricaine',
    countryCode: 'CF',
    currencyCode: 'XAF',
    currencyNameEn: 'Central African CFA',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '236',
    region: 'Africa',
    flag: '🇨🇫',
    countryCodeAlpha3: 'CAF',
    center: [7, 21],
  },
  {
    countryNameEn: 'Cook Islands',
    countryNameLocal: "Kūki 'Āirani",
    countryCode: 'CK',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '682',
    region: 'South Pacific Ocean',
    flag: '🇨🇰',
    countryCodeAlpha3: 'COK',
    center: [-21.2333, -159.7667],
  },
  {
    countryNameEn: 'Falkland Islands',
    countryNameLocal: 'Falkland Islands',
    countryCode: 'FK',
    currencyCode: 'FKP',
    currencyNameEn: 'Falklands pound',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '500',
    region: 'South Atlantic Ocean',
    flag: '🇫🇰',
    countryCodeAlpha3: 'FLK',
    center: [-51.75, -59],
  },
  {
    countryNameEn: 'Faroe Islands',
    countryNameLocal: 'Færøerne',
    countryCode: 'FO',
    currencyCode: 'DKK',
    currencyNameEn: 'Faroese króna',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'da',
    officialLanguageNameEn: 'Danish',
    officialLanguageNameLocal: 'dansk',
    countryCallingCode: '298',
    region: 'Europe',
    flag: '🇫🇴',
    countryCodeAlpha3: 'FRO',
    center: [62, -7],
  },
  {
    countryNameEn: 'Territory of Heard Island and McDonald Islands',
    countryNameLocal: 'Territory of Heard Island and McDonald Islands',
    countryCode: 'HM',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '672',
    region: 'Indian Ocean',
    flag: '🇭🇲',
    countryCodeAlpha3: 'HMD',
    center: [-53.1, 72.5167],
  },
  {
    countryNameEn: 'British Indian Ocean Territory',
    countryNameLocal: 'British Indian Ocean Territory',
    countryCode: 'IO',
    currencyCode: 'USD',
    currencyNameEn: 'United States Dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '246',
    region: 'Indian Ocean',
    flag: '🇮🇴',
    countryCodeAlpha3: 'IOT',
    center: [-6, 71.5],
  },
  {
    countryNameEn: 'Comoros',
    countryNameLocal: 'Umoja wa Komori',
    countryCode: 'KM',
    currencyCode: 'KMF',
    currencyNameEn: 'Comorian franc',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '269',
    region: 'Indian Ocean',
    flag: '🇰🇲',
    countryCodeAlpha3: 'COM',
    center: [-12.1667, 44.25],
  },
  {
    countryNameEn: 'Cayman Islands',
    countryNameLocal: 'Cayman Islands',
    countryCode: 'KY',
    currencyCode: 'KYD',
    currencyNameEn: 'Cayman Islands dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1 345',
    region: 'Caribbean Sea',
    flag: '🇰🇾',
    countryCodeAlpha3: 'CYM',
    center: [19.5, -80.5],
  },
  {
    countryNameEn: 'Republic of the Marshall Islands',
    countryNameLocal: 'Aolepān Aorōkin Ṃajeḷ',
    countryCode: 'MH',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '692',
    region: 'Pacific Ocean',
    flag: '🇲🇭',
    countryCodeAlpha3: 'MHL',
    center: [9, 168],
  },
  {
    countryNameEn: 'Commonwealth of the Northern Mariana Islands',
    countryNameLocal: 'Sankattan Siha Na Islas Mariånas',
    countryCode: 'MP',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1 670',
    region: 'Pacific Ocean',
    flag: '🇲🇵',
    countryCodeAlpha3: 'MNP',
    center: [15.2, 145.75],
  },
  {
    countryNameEn: 'Turks and Caicos Islands',
    countryNameLocal: 'Turks and Caicos Islands',
    countryCode: 'TC',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '1 649',
    region: 'Atlantic Ocean',
    flag: '🇹🇨',
    countryCodeAlpha3: 'TCA',
    center: [21.75, -71.5833],
  },
  {
    countryNameEn: 'French Southern and Antarctic Lands',
    countryNameLocal: 'Terres australes et antarctiques françaises',
    countryCode: 'TF',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'fr',
    officialLanguageNameEn: 'French',
    officialLanguageNameLocal: 'Français',
    countryCallingCode: '672',
    region: 'Indian Ocean',
    flag: '🇹🇫',
    countryCodeAlpha3: 'ATF',
    center: [-43, 67],
  },
  {
    countryNameEn: 'United States Minor Outlying Islands',
    countryNameLocal: 'United States Minor Outlying Islands',
    countryCode: 'UM',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'en',
    officialLanguageNameEn: 'English',
    officialLanguageNameLocal: 'English',
    countryCallingCode: '246',
    region: 'Pacific Ocean',
    flag: '🇺🇲',
    countryCodeAlpha3: 'UMI',
    center: [19.2833, 166.6],
  },
  {
    countryNameEn: 'Holy See',
    countryNameLocal: 'Sancta Sedes',
    countryCode: 'VA',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'la',
    officialLanguageNameEn: 'Latin',
    officialLanguageNameLocal: 'lingua latīna',
    countryCallingCode: '39',
    region: 'Europe',
    flag: '🇻🇦',
    countryCodeAlpha3: 'VAT',
    center: [41.9, 12.45],
  },
  {
    countryNameEn: 'Republic of Kosovo',
    countryNameLocal: 'Republika e Kosovës',
    countryCode: 'XK',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'sq',
    officialLanguageNameEn: 'Albanian',
    officialLanguageNameLocal: 'Shqip',
    countryCallingCode: '383',
    region: 'Europe',
    flag: '🇽🇰',
    center: [42.56, 20.34],
  },
  {
    countryNameEn: 'Netherlands Antilles',
    countryNameLocal: 'Nederlandse Antillen',
    countryCode: 'AN',
    currencyCode: 'ANG',
    currencyNameEn: 'Netherlands Antillean guilder',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'nl',
    officialLanguageNameEn: 'Dutch, Flemish',
    officialLanguageNameLocal: 'Nederlands, Vlaams',
    countryCallingCode: '599',
    region: 'Europe',
    flag: '🇧🇶',
    countryCodeAlpha3: 'ANT',
    center: [12.25, -68.75],
  },
  {
    countryNameEn: 'Turkish Republic of Northern Cyprus',
    countryNameLocal: 'Kuzey Kıbrıs Türk Cumhuriyeti',
    countryCode: 'XT',
    currencyCode: 'TRY',
    currencyNameEn: 'Turkish lira',
    tinType: '',
    tinName: '',
    officialLanguageCode: 'tr',
    officialLanguageNameEn: 'Turkish',
    officialLanguageNameLocal: 'Türkçe',
    countryCallingCode: '90',
    region: 'Europe',
    flag: 'xt',
    countryCodeAlpha3: '-99',
    center: [35.24, -33.58],
  },
]
